import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Nav,
  Row,
  Tab,
  Table,
  Spinner,
  Modal,
  Alert,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Link, useNavigate, useNavigation, useSearchParams } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import Dropzone from "react-dropzone";
import { useLocation } from "react-router-dom";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "../../../helpers/stripe/cardUtils";
import { useSelector, useDispatch } from "react-redux";
import { Document, Page } from "react-pdf";
import {
  createUserProfile,
  deleteDocument,
  geCompanyData,
  handleStripePackage,
  getSubscribedUser,
  getCards,
  getAllCategories,
  getSubCategories,
  checkVideoPaymentStatus,
  handleVideoPackage,
  getRecentWork,
} from "../../../slices/thunk";
import "react-toastify/dist/ReactToastify.css";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { createSelector } from "reselect";
import { userPackage } from "slices/payment/reducer";
import AddRecentWork from "./recent-work/AddRecentWork";
import RecentWorkList from "./recent-work/RecentWork";
import withRouter from "Common/withRouter";
import { useTranslation, withTranslation } from "react-i18next";
import axios from "axios";
import Stripe from "./stripe";
import { TwoButtonAlert } from "../../../Common/twoButtonAlert";
import {
  IoCheckmarkCircle,
  IoCheckmarkCircleOutline,
  IoTrashOutline,
  IoWarning,
} from "react-icons/io5";
import { CallAPIPostPromise } from "Common/commaon";
import { cancelSubscription, getDecodeId } from "slices/userProfile/thunk";
import { Slide, ToastContainer, toast } from "react-toastify";
import { pricingdata } from "pages/Contracts/CreateProject/Tutorial/components/pricing";
import SubscriptionModal from "pages/stripe/subriptionModal";
import { useDebounce } from "Common/Hooks/UserHooks";
import { Elements } from "@stripe/react-stripe-js";
import apiUrl, { stripePromise, stripePromiseTest } from "slices/apiEndpoint";
import { selectPaymentProvider, selectUserDetails } from "slices/userProfile/reducer";
import { CalendarClock, Check, CheckCircle2, Clock3, CreditCard, MapPin, ShieldCheck, Sparkles, UserCheck } from "lucide-react";
import girlScrolling from '../../../assets/images/girlScrolling.jpg'
import { SubscriptionCancelldModal } from "components/SubcriptionCanceldModal";
import DeluxeSubscriptionModal from "components/deluxe/deluxDeluxSubcriptionModal";
import moment from "moment";
import ContractorCompliancePanel from "./ContractorCompliancePanel";
import api from "Common/api";
import { useBillingAccess } from "components/BillingAccessContext";

const PROFILE_IMAGE_ACCEPT = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
};
declare const EmbeddedPayments: any;
interface PersonalDataProps {
  data: any;
  userD: any;
  companyD: any;
  licenceImage: any;
  contractorLicenceImage: any;
  insuranceImage: any;
  profileVideo: any;
  compLogo: any;
  isLoading: any;
  onRemoveImage: (type: string) => void;
  createUserData: (values: any,isNext?:any,inputName?:any) => void;
  createCompanyData: (values: any,type?:any,url?:any,isNext?:any,inputName?:any) => void;
  onFileChange: (type: string, filePath: any) => void;
  handleActivetab: (type: string) => void;
  isPaymentVerified: Boolean;
  companyLicLoading: Boolean;
  insuranceLoading: Boolean;
  contLicLoading: Boolean;
  compLogoLoading: Boolean;
  profileVidLoading: Boolean;
  identityLoading?: Boolean;
  complianceUploadingType?: string | null;
  activeT: string;
  userType: string;
  props: any;
  error:any,
  selectedInput:any;
  mobilePortfolio?: React.ReactNode;
}
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 

const RequiredMark = () => (
  <>
    <span className="profile-settings-required-mark" aria-hidden="true">
      *
    </span>
    <span className="visually-hidden"> required</span>
  </>
);

const Personal: React.FC<PersonalDataProps> = ({
  data,error,selectedInput,
  userD,
  companyD,
  isLoading,
  createUserData,
  createCompanyData,
  onFileChange,
  handleActivetab,
  licenceImage,
  contractorLicenceImage,
  insuranceImage,
  compLogo,
  profileVideo,
  onRemoveImage,
  isPaymentVerified,
  companyLicLoading,
  insuranceLoading,
  contLicLoading,
  compLogoLoading,
  profileVidLoading,
  identityLoading,
  complianceUploadingType,
  activeT,
  userType,
  props,
  mobilePortfolio,
}) => {
  const { t } = useTranslation(); // ✅ React knows to update
  const { state: billingAccess, completePaymentRecovery } = useBillingAccess();
  const paymentProvider = useSelector(selectPaymentProvider);
 
  const [subriptionModalStatus, setSubriptionModalStatus] =
    useState<boolean>(false);
  const navigate = useNavigate();
  //console.log(licenceImage, "licenceImagelicenceImage");
  const dispatch: any = useDispatch();
  const [text, setText] = useState("");
  const [addNewCardDetailsOpen, setAddNewCardDetailsOpen] = useState(false);
  const [deluxeJwt, setDeluxeJwt] = useState<string | null>(null);
  const [deluxeSdkRendered, setDeluxeSdkRendered] = useState(false);
  const [deluxeMessage, setDeluxeMessage] = useState("");
  const [isSavingDeluxeCard, setIsSavingDeluxeCard] = useState(false);
  const [pendingRecoveryCard, setPendingRecoveryCard] = useState<{ show: boolean; paymentMethodId: string }>({
    show: false,
    paymentMethodId: "",
  });
  const [recoveryConsentAccepted, setRecoveryConsentAccepted] = useState(false);
  const [isRecoveringSubscription, setIsRecoveringSubscription] = useState(false);
  const [recoveryError, setRecoveryError] = useState("");
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [isLicenceUploading, setIsLicenceUploading] = useState<boolean>(false);
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState("");
  const [userFormattedPhoneNumber, setUserFormattedPhoneNumber] = useState("");
  const [cardData, setCardData] = useState<any[]>([]);
  const [isFetchSavedCardrun,setIsFecthSavedCardsRun]=useState(true)
  const [profileOptions, setProfileOptions] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [userSkills, setUserSkills] = useState<any>([]);
  const [showCompany, setShowCompany] = useState<any>(true);
  const [modal_video_payment, setModalVideoPayment] = useState(false);
  const [insuranceImagePath, setInsuranceImagePath] = useState<string>("");
  const [companyLicenceImagePath, setCompanyLicenceImagePath] =
    useState<string>("");
  const [planDetails, setPlanDetails] = useState("");
  const [isSubCancelledOpen,setIsSUbCanceldOpen]=useState(false)
  const [deletingDocumentType, setDeletingDocumentType] = useState<string>("");
  const [alertDetails, setAlertDetails] = useState({
    status: false,
    title: "Warning!",
    message: "You are about to delete your account permanently.",
    icon: IoTrashOutline,
    button1Text: "Keep it",
    button2Text: "Delete",
    button1Style:
      "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
    button2Style:
      "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
    onButton1Click: () => {},
    onButton2Click: () => {},
  });
  const [contractorLicenceImagePath, setContractorLicenceImagePath] =
    useState<string>("");
  const acceptedFileTypes = [".png", ".jpg", ".jpeg"];
  const acceptedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];
  const deluxeInitializedRef = useRef(false);
  const deluxeTokenSuccessCalledRef = useRef(false);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
  const [zipcodeError,setZipCodeError] = useState("")
  const [insuranceAnswer, setInsuranceAnswer] = useState<"yes" | "no" | "unsure">("unsure");

  const userID = getDecodeId();

  const offerPendingPaymentRecovery = useCallback((paymentMethodId?: string) => {
    if (!paymentMethodId || !billingAccess?.actionRequired || Number(billingAccess.outstandingAmount || 0) <= 0) {
      return;
    }
    setRecoveryConsentAccepted(false);
    setRecoveryError("");
    setPendingRecoveryCard({ show: true, paymentMethodId });
  }, [billingAccess?.actionRequired, billingAccess?.outstandingAmount]);

  const closePendingPaymentConsent = () => {
    if (isRecoveringSubscription) return;
    setPendingRecoveryCard({ show: false, paymentMethodId: "" });
    setRecoveryConsentAccepted(false);
    setRecoveryError("");
  };

  const recoverPendingPaymentWithNewCard = async () => {
    if (!recoveryConsentAccepted || !pendingRecoveryCard.paymentMethodId || !billingAccess) return;
    setIsRecoveringSubscription(true);
    setRecoveryError("");
    try {
      const response: any = await api.post("/stripe-sub/recover-subscription", {
        provider: paymentProvider,
        paymentMethodId: pendingRecoveryCard.paymentMethodId,
        consent: true,
        consentSource: "new-card-payment-settings",
      });
      completePaymentRecovery(response.data);
      setPendingRecoveryCard({ show: false, paymentMethodId: "" });
      setRecoveryConsentAccepted(false);
      toast.success("Outstanding subscription payment completed. Your service is active again.");
    } catch (requestError: any) {
      setRecoveryError(
        requestError?.response?.data?.message ||
        requestError?.message ||
        "The outstanding payment could not be completed. Your new card is still saved."
      );
    } finally {
      setIsRecoveringSubscription(false);
    }
  };
  useEffect(() => {
    dispatch(getAllCategories()).then((resp: any) => {
      const data = resp.result;
      const transformedData = data.map((item: any) => ({
        value: item.cat_id,
        label: item.cat_name,
      }));
      setProfileOptions(transformedData);
    });

    if (data && data.ua_skills) {
      try {
        const parsedArray = JSON.parse(data.ua_skills);
        const formattedSkills = parsedArray.map((skill: any) => ({
          value: skill.value,
          label: skill.label,
        }));
        //console.log(formattedSkills, "formattedSkillsformattedSkills")
        setSelectedOptions(formattedSkills);
      } catch (error) {
        console.error("Error parsing skills:", error);
      }
    }
  }, [dispatch, data]);

  const handleProfileOnchange = (selectedProfile: any): Promise<void> => {
    return new Promise((resolve, reject) => {
      dispatch(getSubCategories(selectedProfile.value))
        .then((resp: any) => {
          const data = resp.result || [];
          const transformedData: any = data.map((item: any) => ({
            value: item.sc_category,
            label: item.sc_category,
          }));
  
          setUserSkills(transformedData); // Replace previous skills with new ones
          validation.setFieldValue("profile", selectedProfile);
  
          resolve();
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  };
  
  const handleSelectedOptionsChange = (selectedSkills: any) => {
    setSelectedOptions(selectedSkills);
    validation.setFieldValue("skills", selectedSkills);
  };

  const workAvailable = [
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
  ];

  const [selectedFiles, setselectedFiles] = useState<any>([]);
  const [activeTab, setActiveTab] = useState(activeT);
  const [loading, setLoading] = useState(true);
  const [isPackagesLoading, setIsPackagesLoading] = useState(true);
  const [isInitialProfileLoad, setIsInitialProfileLoad] = useState(true);

  const userSubscribed = useSelector(
    (state: any) => state.UserProfile.subscribedData
  );
  const trialEligible = userSubscribed?.trialEligible === true;
  const pendingYearlySwitch = userSubscribed?.pendingPlanChange?.targetPlan === "yearly"
    ? userSubscribed.pendingPlanChange
    : null;
  const pendingYearlySwitchDate = pendingYearlySwitch?.effectiveAt
    ? new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      }).format(new Date(pendingYearlySwitch.effectiveAt))
    : null;

  useEffect(() => {
    setLoading(true);
    setIsPackagesLoading(true);
    dispatch(getSubscribedUser()).finally(() => {
      setLoading(false);
      setIsPackagesLoading(false);
      setIsInitialProfileLoad(false);
    });
  }, [dispatch]);

  const handlePrimaryCard = (card: any) => {
    const request = paymentProvider === "deluxe"
      ? CallAPIPostPromise("/v2/api/deluxe/set-primary-card", {
          paymentMethodId: card.paymentMethodId,
        })
      : CallAPIPostPromise("/stripe/api/set-primary-card", {
          paymentMethodId: card.id,
          userId: userID,
          customerId: card.customer,
        });

    request.then(() => {
      const selectedPaymentMethodId = paymentProvider === "deluxe"
        ? card.paymentMethodId
        : card.id;
      setCardData((currentCards: any[]) => currentCards.map((currentCard: any) => ({
        ...currentCard,
        isPrimary: (currentCard.paymentMethodId || currentCard.id) === selectedPaymentMethodId,
      })));
      toast("Card set to primary.", {
        position: "top-right",
        hideProgressBar: true,
        className: "bg-primary text-white",
        transition: Slide,
      });
      fetchSavedCard();
    }).catch((error: any) => {
      toast.error(error?.message || "Unable to set the primary card.");
    });
  };

  const detachCard = (card: any) => {
    CallAPIPostPromise("/stripe/api/detach-card", {
      paymentMethodId: card.id,
      userId: userID,
    }).then(() => {
      toast("Card Detached", {
        position: "top-right",
        hideProgressBar: true,
        className: "bg-primary text-white",
        transition: Slide,
      });
      fetchSavedCard();
    });
  };

  // Validation function to check for special characters in the file name
  function validateFileName(fileName: string) {
    const invalidChars = /[!@#\$%\^&\*\(\)\+=\{\}\[\]\|\\;:'",<>\/?]/;
    return !invalidChars.test(fileName); // Returns true if valid, false if invalid
  }
  function handleInsuranceImageChange(files: any) {
    setIsUploading(true);
  
    // Check if the file name is valid
    if (!validateFileName(files[0].name)) {
      alert(
        "Invalid file name. Please avoid special characters such as !@#$%^&*()+={}[]|\\;:'\",<>/?"
      );
      setIsUploading(false);
      return; // Stop further execution
    }
  
    // Check file size (limit: 15MB)
    const maxSize = 15 * 1024 * 1024; // 15 MB
    if (files[0].size > maxSize) {
      alert("File size exceeds 15MB limit. Please upload a smaller file.");
      setIsUploading(false);
      return; // Stop further execution
    }
  
    // Format and preview file
    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
  
    onFileChange("insurance", files[0]);
    setselectedFiles(files);
    setIsUploading(false);
  }
  

  function handleCompanyLogoChange(files: any) {
    setIsUploading(true);

    if (!validateFileName(files[0].name)) {
      alert(
        "Invalid file name. Please avoid special characters such as !@#$%^&*()+={}[]|\\;:'\",<>/?"
      );
      setIsUploading(false);
      return;
    }

    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    onFileChange("companyLogo", files[0]);
    setselectedFiles(files);
    setIsUploading(false);
  }

  function handleCompanyLicenceImageChange(files: any) {
    if (!validateFileName(files[0].name)) {
      alert(
        "Invalid file name. Please avoid special characters such as !@#$%^&*()+={}[]|\\;:'\",<>/?"
      );
      return;
    }
    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    onFileChange("companyLicence", files[0]);
    setselectedFiles(files);
  }

  function handleContractorLicenceImageChange(files: any) {
    if (!validateFileName(files[0].name)) {
      alert(
        "Invalid file name. Please avoid special characters such as !@#$%^&*()+={}[]|\\;:'\",<>/?"
      );
      return;
    }

    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    onFileChange("contractorLicence", files[0]);

    setselectedFiles(files);
  }

  function handleProfileVideoChange(files: any) {
    setIsUploading(true);

    const videoFile = files[0];
    const videoElement = document.createElement("video");

    videoElement.src = URL.createObjectURL(videoFile);

    videoElement.onloadedmetadata = () => {
      if (videoElement.duration > 30) {
        dispatch(checkVideoPaymentStatus()).then((resp: any) => {
          if (resp.status === false) {
            setModalVideoPayment(true);
            setIsUploading(false);
          } else if (videoElement.duration > 60) {
            alert("Sorry, the limit to upload a video is only 60 seconds.");
            setIsUploading(false);
          } else {
            setIsUploading(true);
            // Proceed with the rest of the code if the video duration is within the limit
            finalizeVideoUpload(files);
          }
        });
      } else {
        setIsUploading(true);
        // Proceed with the rest of the code if the video duration is within the limit
        finalizeVideoUpload(files);
      }
    };

    videoElement.onerror = () => {
      alert(
        "There was an error loading the video. Please try a different file."
      );
      setIsUploading(false);
    };
  }

  function finalizeVideoUpload(files: any) {
    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    onFileChange("profileVideo", files[0]);
    setselectedFiles(files);
    setIsUploading(false);
  }

  function tog_modal_video_payment() {
    setModalVideoPayment(!modal_video_payment);
  }
  useEffect(() => {
    // Function to handle the click event
    const handleClickOutside = (event: MouseEvent) => {
      // Get the modal elements
      const backdropElement = document.getElementById("staticBackdrop");

      // Check if the click is outside the modal
      if (backdropElement && !backdropElement.contains(event.target as Node)) {
        // Close the modals if they are open
        if (modal_video_payment) {
          setModalVideoPayment(false);
        }
      }
    };

    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modal_video_payment]);

  function handleRemoveInsuranceImage(type: string) {
    onRemoveImage(type);
  }

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const selectAllOption = { value: "*", label: "Select All" };
  const customStyles = {
    multiValue: (styles: any, { data }: any) => {
      return {
        ...styles,
        backgroundColor: "#3762ea",
      };
    },
    multiValueLabel: (styles: any, { data }: any) => ({
      ...styles,
      backgroundColor: "#3762ea",
      color: "white",
    }),
    multiValueRemove: (styles: any, { data }: any) => ({
      ...styles,
      color: "white",
      backgroundColor: "#3762ea",
      ":hover": {
        backgroundColor: "#3762ea",
        color: "white",
      },
    }),
  };
  const userd:any = useSelector(selectUserDetails)
  const isEmployee = userd[0]?.is_test_stripe_user ===1
  const formatPhoneNumber = (phoneNumber: string) => {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  };
  const [companyPhoneErr,setCompanyPhoneErr] = useState("")
  const [companyEmailErr,setCompanyEmailErr] = useState("")
  // Function to handle input change for company phone number
  const handleCompanyPhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = event.target.value.replace(/\D/g, ""); // Remove all non-numeric characters
    setFormattedPhoneNumber(formatPhoneNumber(input));
    if(input.length!==10){
      setCompanyPhoneErr("Company Phone Must be 10 digit")
    }else{
      setCompanyPhoneErr("")
      debouncedUpdateCompany({ ...companyValidation.values, companyPhoneNumber: event.target.value },false,"companyPhoneNumber");

    }
    companyValidation.setFieldValue("companyPhoneNumber", input);
  };

  const handlePhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = event.target.value.replace(/\D/g, ""); // Remove all non-numeric characters
    setUserFormattedPhoneNumber(formatPhoneNumber(input));
    validation.setFieldValue("phoneNumber", input);
  };

  let parsedArray = [];
  if (data) {
    const stringArray = data && data.ua_skills ? data.ua_skills : null;
    parsedArray = JSON.parse(stringArray);
  }
  let parsedProflie = [];
  if (data) {
    const stringArray = data && data.ua_profile ? data.ua_profile : null;
    parsedProflie = JSON.parse(stringArray);
  }

  let parsedAvailArray = [];
  if (data) {
    const stringArray =
      data && data.ua_work_availbility ? data.ua_work_availbility : null;
    parsedAvailArray = JSON.parse(stringArray);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: (userD && userD.user_first_name) || "",
      lastName: (userD && userD.user_last_name) || "",
      phoneNumber: (userD && userD.user_phone) || "",
      email: (userD && userD.user_email) || "",
      birthDate: (data != null && data.ua_birth_date) || "",
      joiningDate: (userD  && userD.created_at) || "",
      profile: parsedProflie || [],
      skills: parsedArray || [],
      workAvailability: parsedAvailArray || [],
      experience: (data != null && data.ua_exp) || "",
      workHours: (data != null && data.ua_work_hours) || "",
      cityInput: (data != null && data.ua_city) || "",
      userState: (data != null && data.ua_state) || "",
      zipcodeInput: (data != null && data.ua_zip_code) || "",
      countryInput: (data != null && data.ua_country) || "United States",
      descpription: (data != null && data.ua_description) || "",
      address: (data != null && data.ua_address) || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please enter your first name"),
      lastName: Yup.string().required("Please enter your last name"),
      phoneNumber: Yup.string().required("Please enter your phone number"),
      email: Yup.string().required("Please enter your email address"),
      experience: Yup.string().required("Please enter your years of experience"),
      workHours: Yup.string().required("Please enter your work hours"),
      cityInput: Yup.string().required("Please enter your city"),
      zipcodeInput: Yup.string().required("Please enter your zip code"),
      descpription: Yup.string().required("Please enter your description"),
      address: Yup.string().required("Please enter your address"),
    }),
    onSubmit: (values,from) => {
      createUserData(values);
    },
    
  });

  const companyValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      companyName: (companyD && companyD.cc_company_name) || "",
      companyRegisterdNumber:
        (companyD && companyD.cc_company_registered_number) || "",
      federalTaxId: (companyD && companyD.cc_federal_tax_id) || "",
      companyPhoneNumber: (companyD && companyD.cc_phone_number) || "",
      companyEmail: (companyD && companyD.cc_company_email) || "",
      companyRegisterdDate: (companyD && companyD.cc_registration_date) || "",
      companyCity: (companyD && companyD.cc_city) || "",
      companyAddress: (companyD && companyD.cc_address) || "",
      companyState: (companyD && companyD.cc_state) || "",
      companyZip: (companyD && companyD.cc_zip_code) || "",
      companyCountry: (companyD && companyD.cc_country) || "",
      companyInsuranceDocument:
        (companyD && companyD.cc_insurance_documentation_url) || "",
      companyLicenceDocument:
        (companyD && companyD.cc_licence_documentation_url) || "",
      companyContractorDocument:
        (companyD && companyD.cc_contractor_documentation_url) || "",
      //companyLogo: (companyD && userD.user_last_name) || "",
    },
    validationSchema: Yup.object({
      companyPhoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(
        /^[0-9]{10}$/,
        "Phone number must be 10 digits"
      ),
    companyEmail: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    federalTaxId: Yup.string().when("companyState", {
      is: "OH",
      then: (schema) => schema.matches(/^\d{9}$/, "Federal Tax ID/EIN must be 9 digits").required("Federal Tax ID/EIN is required for Ohio contractors"),
      otherwise: (schema) => schema.notRequired(),
    }),
    }),
    onSubmit: (values) => {
      createCompanyData(values);
    },
  });
  function handleActive(type: any) {
    handleActivetab(type);
  }

const updatePersonalDetails =(values?:any,inputName?:any)=>{
createUserData(values?values: validation.values,'ignoreNextPage',inputName)
}

const updateCompanyDetails= (values?:any,inputName?:any)=>{
  createCompanyData(values?values:companyValidation.values,"","",'ignoreNextPage',inputName);

}
const debouncedUpdateCompany = useDebounce((values: any,isCompanyEmail?:any,inputName?:any) => {
  if(isCompanyEmail){
if(!emailRegex.test(values.companyEmail)){
 return
}
  }
  updateCompanyDetails(values,inputName);
 }, 1000); // 1s debounce
  async function deletDoc(type: any) {
    if (deletingDocumentType) return;

    setDeletingDocumentType(type);
    try {
      await dispatch(deleteDocument(type));
      onRemoveImage(type);
      await dispatch(geCompanyData());
      toast.success("Document deleted successfully.");
    } catch (error) {
      toast.warning("Failed to delete document. Please try again.");
    } finally {
      setDeletingDocumentType("");
    }
  }
  const debouncedUpdateUser = useDebounce((values: any,name?:any) => {
    updatePersonalDetails(values,name)
  }, 1000); // 1s debounce
  useEffect(() => {
    if (companyValidation.values.companyPhoneNumber) {
      const formattedNumber = formatPhoneNumber(
        companyValidation.values.companyPhoneNumber
      );
      setFormattedPhoneNumber(formattedNumber);
    }
  }, [companyValidation.values.companyPhoneNumber]);

  useEffect(() => {
    if (validation.values.phoneNumber) {
      const userFormattedPhoneNumber = formatPhoneNumber(
        validation.values.phoneNumber
      );
      setUserFormattedPhoneNumber(userFormattedPhoneNumber);
    }
  }, [validation.values.phoneNumber]);
  const handleStripePc = (plan: any) => {
    setPlanDetails(plan);
    setSubriptionModalStatus(true);
  };
  const scheduleYearlySwitch = async (plan: any) => {
    setLoading(true);
    setIsPackagesLoading(true);
    try {
      const response: any = await api.post("/stripe-sub/switch-to-yearly", {
        yearlyPriceId: isEmployee ? plan?.regular_priceIDTest : plan?.regular_priceID,
      });
      await dispatch(getSubscribedUser());
      toast.success(response?.message || "Your yearly plan will start at the next renewal.");
    } catch (requestError: any) {
      const errorData = requestError?.response?.data;
      const errorMessage =
        errorData?.message ||
        requestError?.message ||
        "The yearly plan switch could not be scheduled.";
      toast.warning(errorData?.requestId ? `${errorMessage} Reference: ${errorData.requestId}` : errorMessage);
    } finally {
      setLoading(false);
      setIsPackagesLoading(false);
    }
  };

  const confirmYearlySwitch = (plan: any) => {
    setAlertDetails({
      status: true,
      title: "Switch to yearly billing?",
      message: "Your monthly plan will remain active. Yearly billing will start automatically on your next renewal date, with no charge today.",
      icon: IoCheckmarkCircleOutline,
      button1Text: "Keep monthly",
      button2Text: "Schedule switch",
      button1Style: "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
      button2Style: "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition",
      onButton1Click: () => {},
      onButton2Click: () => { void scheduleYearlySwitch(plan); },
    });
  };
  const fetchSavedCard = async () => {
    if (!userD?.id || !paymentProvider || userType !== "contractor") {
      setCardData([]);
      setIsFecthSavedCardsRun(false);
      return;
    }

    setIsFecthSavedCardsRun(true);
    try {
      if(paymentProvider ==="stripe"){
        const resp = await dispatch(getCards(userD.id));
        setCardData(resp || []);
      }
      if(paymentProvider ==="deluxe"){
        const resp = await  CallAPIPostPromise(`/v2/api/deluxe/getSavedCards/`,{
          email:userD.user_email,
          userId:userD.id
        }) as any;
        setCardData(resp?.cards || []);
      }
    } catch (error) {
      console.log(error);
      setCardData([]);
    } finally {
      setIsFecthSavedCardsRun(false);
    }
  };
  useEffect(() => {
    if (userD?.id && paymentProvider && userType === "contractor") {
      fetchSavedCard();
    } else {
      setCardData([]);
      setIsFecthSavedCardsRun(false);
    }
  }, [userD?.id, paymentProvider, userType]);

  useEffect(() => {
    if (paymentProvider !== "deluxe" || !addNewCardDetailsOpen) {
      setDeluxeJwt(null);
      setDeluxeSdkRendered(false);
      setDeluxeMessage("");
      deluxeInitializedRef.current = false;
      deluxeTokenSuccessCalledRef.current = false;
      return;
    }

    const fetchDeluxeJwt = async () => {
      try {
        setDeluxeMessage("");
        setDeluxeSdkRendered(false);
        deluxeInitializedRef.current = false;
        deluxeTokenSuccessCalledRef.current = false;

        const resp = await api.post(`/v2/api/deluxe/create-jwt`, {
          userId: userD?.id,
          email: userD?.user_email,
        }) as any;

        if (!resp?.jwt) throw new Error("JWT missing");
        setDeluxeJwt(resp.jwt);
      } catch (error) {
        console.log(error);
        setDeluxeMessage("Unable to initialize Deluxe card form. Please try again.");
      }
    };

    fetchDeluxeJwt();
  }, [paymentProvider, addNewCardDetailsOpen, userD?.id, userD?.user_email]);

  useEffect(() => {
    if (paymentProvider !== "deluxe" || !addNewCardDetailsOpen || !deluxeJwt) return;

    if (typeof EmbeddedPayments === "undefined") {
      setDeluxeMessage("Deluxe payment form is still loading. Please try again.");
      return;
    }

    const container = document.getElementById("profile-deluxe-embeddedpayments");
    if (!container || deluxeInitializedRef.current) return;

    deluxeInitializedRef.current = true;
    setDeluxeSdkRendered(false);

    EmbeddedPayments.init(deluxeJwt, {
      countryCode: "US",
      currencyCode: "USD",
      paymentMethods: ["cc"],
      collectBillingAddress: false,
      collectShippingAddress: false,
      requireBillingAddress: false,
      skipSellerStatusCheck: true,
      skipCompleteAuthorization: true,
    })
      .then((instance: any) => {
        instance
          .setEventHandlers({
            onTxnSuccess: () => {},
            onTxnFailed: () => {},
            onTxnAuthorized: () => {},
            onValidationError: (_gateway: any, errors: any) => {
              console.log("Deluxe validation error", errors);
            },
            onCancel: () => {},
            onTokenSuccess: async (_gateway: string, data: any) => {
              if (deluxeTokenSuccessCalledRef.current) return;
              deluxeTokenSuccessCalledRef.current = true;

              const token = data?.Token || data?.token;
              const expiry = data?.ExpMonthYear || data?.expiry;

              if (!token || !expiry) {
                deluxeTokenSuccessCalledRef.current = false;
                setDeluxeMessage("Token not received properly. Try again.");
                return;
              }

              try {
                setIsSavingDeluxeCard(true);
                setDeluxeMessage("");
                const savedCard: any = await api.post(`/v2/api/deluxe/save-customer-card`, {
                  userId: userD?.id,
                  email: userD?.user_email,
                  token,
                  expiry,
                });
                toast.success("Card added successfully.");
                setAddNewCardDetailsOpen(false);
                fetchSavedCard();
                offerPendingPaymentRecovery(savedCard?.paymentMethodId);
              } catch (error: any) {
                console.log(error);
                deluxeTokenSuccessCalledRef.current = false;
                setDeluxeMessage(
                  error?.response?.data?.message ||
                    error?.message ||
                    "Failed to save Deluxe card. Try again."
                );
              } finally {
                setIsSavingDeluxeCard(false);
              }
            },
            onTokenFailed: () => {
              setDeluxeMessage("Unable to tokenize card. Please try again.");
            },
          })
          .render({
            containerId: "profile-deluxe-embeddedpayments",
            paymentpanelstyle: "light",
            paybuttoncolor: "#2563eb",
            cancelbuttoncolor: "#ef4444",
          });

        setTimeout(() => {
          setDeluxeSdkRendered(true);
        }, 150);
      })
      .catch((error: any) => {
        console.log(error);
        deluxeInitializedRef.current = false;
        setDeluxeSdkRendered(false);
        setDeluxeMessage("Unable to load Deluxe card form. Please refresh and try again.");
      });
  }, [paymentProvider, addNewCardDetailsOpen, deluxeJwt, userD?.id, userD?.user_email, offerPendingPaymentRecovery]);

  const isRegistered = (e: any) => {
    if (e.target.checked) {
      setShowCompany(false);
    } else {
      setShowCompany(true);
    }
  };
  const handleVideoPackageFunc = (type: any) => {
    setLoading(true);
    let values = {
      package: type,
      email: userD && userD.user_email,
    };
    dispatch(handleVideoPackage(values)).finally(() => {
      setLoading(false);
    });
  };
  const handleAlertClick = () => {
    setNotification(null);
  };
  const getData = (zip: any, isCompany?: any) => {
    axios
      .get(`${apiUrl}/misc/zipcode/US/${zip}`, {
      })
      .then((resp: any) => {
        const data = resp;
        if (data && data.places && data.places.length > 0) {
          const place = data.places[0];
          if (!isCompany) {
            validation.handleChange({
              target: {
                value: place["place name"]?.replace("City",""),
                name: "cityInput",
                id: "cityInput",
              },
            });
            validation.handleChange({
              target: {
                value:  place["state abbreviation"],
                name: "userState",
                id: "userState",
              },
            });
            validation.handleChange({
              target: {
                value: data["country abbreviation"],
                name: "countryInput",
                id: "countryInput",
              },
            });
            updatePersonalDetails({
              ...validation.values,
              cityInput:place["place name"]?.replace("City",""),
              userState: place["state abbreviation"],
              zipcodeInput:zip,
              countryInput:data["country abbreviation"],
              
            },"zipcodeInput");
          } else {
            companyValidation.handleChange({
              target: {
                value:data["country abbreviation"],
                name: "companyCountry",
                id: "companyCountry",
              },
            });
            companyValidation.handleChange({
              target: {
                value: place["state abbreviation"],
                name: "companyState",
                id: "companyState",
              },
            });
            companyValidation.handleChange({
              target: {
                value: place["place name"]?.replace("City",""),
                name: "companyCity",
                id: "companyCity",
              },
            });
            updateCompanyDetails({
              ...companyValidation.values,
              companyCity: place["place name"]?.replace("City",""),
              companyState:place["state abbreviation"],
              companyCountry:data["country abbreviation"],
              companyZip:zip,

            },"companyZip");
          }
        } else {
          setZipCodeError("Zip Code not found")
     
          setTimeout(() => {
        setZipCodeError("")
          }, 5000);
        
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };
  const handleCancelSubscription = async () => {
    setLoading(true);
    setIsPackagesLoading(true);
    try {
      const resp: any = await dispatch(cancelSubscription());
      await dispatch(getSubscribedUser());
      if(resp?.message){
        setIsSUbCanceldOpen(true)
      }else{
        toast.warning("Soemthing went wrong")
      }
    } finally {
      setLoading(false);
      setIsPackagesLoading(false);
    }
  };
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action")
useEffect(()=>{
if(action==="30days"){
  handleStripePc(pricingdata[1])
}else{
if(action==="yearly"){
  handleStripePc(pricingdata[0])

}

}
},[action])
  const isBrokerOrAgent =
    userType === "real_estate_agent" || userType === "broker";
  const isComplianceContractor =
    userType === "contractor" || userType === "subcontractor";
  const company_broker = isBrokerOrAgent ? "Broker" : "Company";
  const companyProfileSignals = [
    companyValidation.values.companyName,
    companyValidation.values.companyPhoneNumber,
    companyValidation.values.companyEmail,
    companyValidation.values.companyAddress,
    companyValidation.values.companyZip,
    companyValidation.values.companyCity,
    companyValidation.values.companyState,
    companyValidation.values.companyCountry,
    isBrokerOrAgent ? true : companyValidation.values.companyRegisterdNumber,
    isBrokerOrAgent ? true : companyValidation.values.companyRegisterdDate,
    compLogo,
    isBrokerOrAgent ? true : licenceImage,
    isBrokerOrAgent ? true : contractorLicenceImage,
  ];
  const companyProfileCompleted = companyProfileSignals.filter(Boolean).length;
  const companyProfilePercent = Math.round(
    (companyProfileCompleted / companyProfileSignals.length) * 100
  );
  const hasBusinessContact = Boolean(
    companyValidation.values.companyName &&
    companyValidation.values.companyPhoneNumber &&
    companyValidation.values.companyEmail
  );
  const hasBusinessLocation = Boolean(
    companyValidation.values.companyAddress &&
    companyValidation.values.companyZip &&
    companyValidation.values.companyState
  );
  const hasComplianceDocuments = Boolean(
    isBrokerOrAgent ? licenceImage : licenceImage && contractorLicenceImage
  );
  const savedCards = useMemo(() => {
    if (!Array.isArray(cardData)) return [];

    const uniqueCards = new Map<string, any>();
    cardData.forEach((card: any) => {
      const fingerprint = card?.card?.fingerprint;
      const paymentMethodId = card?.paymentMethodId || card?.id;
      const key = fingerprint ? `stripe:${fingerprint}` : `payment-method:${paymentMethodId}`;
      const current = uniqueCards.get(key);

      if (!current || card?.isPrimary || (!current?.isPrimary && Number(card?.created || 0) > Number(current?.created || 0))) {
        uniqueCards.set(key, card);
      }
    });

    return Array.from(uniqueCards.values());
  }, [cardData]);

  const SavedCardSkeleton = () => (
    <div className="grid l:grid-cols-2 gap-2">
      {[0, 1].map((item) => (
        <div key={item} className="rounded-xl border border-gray-200 p-4 animate-pulse">
          <div className="flex items-start justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-gray-200" />
              <div>
                <div className="h-4 w-24 bg-gray-200 rounded mb-2" />
                <div className="h-4 w-36 bg-gray-200 rounded" />
              </div>
            </div>
            <div>
              <div className="h-3 w-16 bg-gray-200 rounded mb-2" />
              <div className="h-4 w-12 bg-gray-200 rounded" />
            </div>
          </div>
          <div className="h-px bg-gray-200 mb-3" />
          <div className="h-9 w-28 bg-gray-200 rounded" />
        </div>
      ))}
    </div>
  );

  const PricingSectionSkeleton = () => (
    <div className="profile-settings-pricing-skeleton" role="status" aria-live="polite">
      <span className="visually-hidden" id="pricing-heading">{t("Loading subscription packages...")}</span>
      <div className="profile-settings-pricing-skeleton-hero" aria-hidden="true">
        <span />
        <strong />
        <p />
      </div>
      <div className="profile-settings-pricing-skeleton-grid" aria-hidden="true">
        {[0, 1].map((item) => (
          <div className="profile-settings-pricing-skeleton-card" key={item}>
            <span />
            <strong />
            <p />
            <button type="button" tabIndex={-1} disabled />
            <div />
            <div />
            <div />
          </div>
        ))}
      </div>
    </div>
  );

  const NoSavedCard = () => (
    <div className="profile-settings-empty-state">
      <CreditCard className="profile-settings-empty-state-icon" />
      <div className="profile-settings-empty-state-title">No saved cards yet</div>
      <div className="profile-settings-empty-state-copy">
        Add a card to keep lead payments and subscription actions ready when you need them.
      </div>
    </div>
  );

  const SavedFieldCheck = ({ field }: { field: string }) =>
    selectedInput === field ? (
      <i className="bi bi-check-circle-fill profile-settings-saved-check" />
    ) : null;

  const isDocumentPreview = (src: any) =>
    typeof src === "string" &&
    (src.endsWith(".pdf") || src.endsWith(".doc") || src.endsWith(".docx"));

  const UploadedPreview = ({
    src,
    type = "image",
    variant = "default",
    title,
    document = false,
    onDelete,
    showDelete = true,
    isDeleting = false,
  }: {
    src: any;
    type?: "image" | "video";
    variant?: "default" | "logo";
    title?: string;
    document?: boolean;
    onDelete?: () => void;
    showDelete?: boolean;
    isDeleting?: boolean;
  }) => {
    if (document) {
      return (
        <div className={`profile-settings-document-file ${isDeleting ? "is-deleting" : ""}`}>
          <div className="profile-settings-document-file-icon" aria-hidden="true">
            <i className="ri-file-text-line" />
          </div>
          <div className="profile-settings-document-file-info">
            <strong>{title || t("Uploaded document")}</strong>
            <span>
              <i className="ri-checkbox-circle-fill" aria-hidden="true" />
              {t("Uploaded and ready to review")}
            </span>
          </div>
          <div className="profile-settings-document-file-actions">
            <a
              className="profile-settings-document-view"
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${t("View")} ${title || t("uploaded document")}`}
            >
              <i className="ri-eye-line" aria-hidden="true" />
              {t("View")}
            </a>
            {showDelete && onDelete && (
              <button
                type="button"
                className="profile-settings-document-remove"
                onClick={onDelete}
                disabled={isDeleting}
                aria-label={`${t("Remove")} ${title || t("uploaded document")}`}
              >
                {isDeleting ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  <i className="ri-delete-bin-line" aria-hidden="true" />
                )}
                <span>{t(isDeleting ? "Removing..." : "Remove")}</span>
              </button>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={`profile-settings-upload-preview-card ${variant === "logo" ? "is-logo" : ""} ${isDeleting ? "is-deleting" : ""}`}>
        <div className="profile-settings-upload-preview-media">
          {type === "video" ? (
            <video src={src} controls />
          ) : isDocumentPreview(src) ? (
            <div className="profile-settings-document-preview">
              <Document file={src}>
                <Page pageNumber={1} />
              </Document>
            </div>
          ) : (
            <img
              src={src}
              alt={variant === "logo" ? t("Company logo preview") : t("Uploaded document preview")}
            />
          )}
        </div>
        {showDelete && onDelete && (
          <button
            type="button"
            className="profile-settings-upload-delete"
            onClick={onDelete}
            disabled={isDeleting}
            aria-label="Remove uploaded file"
          >
            {isDeleting ? (
              <Spinner animation="border" size="sm" role="status" />
            ) : (
              <i className="ri-delete-bin-line" />
            )}
          </button>
        )}
        {isDeleting && (
          <div className="profile-settings-upload-deleting-overlay">
            <Spinner animation="border" size="sm" role="status" />
            <span>{t("Deleting...")}</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {t(notification.message)}
          </Alert>
        </div>
      )}
      {loading && (!isInitialProfileLoad || !data) && (
        <div className="profile-settings-loading-indicator" role="status" aria-live="polite">
          <span className="profile-settings-loading-bar" aria-hidden="true" />
          <span className="profile-settings-loading-pill">
            <Spinner animation="border" size="sm" aria-hidden="true" />
            <span>
              {isInitialProfileLoad
                ? t("Loading profile...")
                : t("Updating profile...")}
            </span>
          </span>
        </div>
      )}
     
      <Col xxl={12} className="profile-settings-main">
        <Tab.Container
       
          id="left-tabs-example"
          activeKey={activeT}
          defaultActiveKey={activeT}
        >
          <Row className="profile-settings-section-nav-row d-flex align-items-center flex-wrap gap-2 mb-4">
            <div className="col-md order-1">
              <Nav
                variant="pills"
                className="profile-settings-section-nav arrow-navtabs nav-secondary gap-2 flex-grow-1"
              >
                {userType !== "real_estate_agent" &&
                userType !== "subcontractor" ? (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="fourth"
                      onClick={() => handleActive("fourth")}
                      href="#packages"
                    >
                      {t("Packages")}
                    </Nav.Link>
                  </Nav.Item>
                ) : (
                  ""
                )}

                <Nav.Item>
                  <Nav.Link
                    eventKey="first"
                    onClick={() => handleActive("first")}
                    href="#personalDetails"
                  >
                    {t("Personal Details")}
                  </Nav.Link>
                </Nav.Item>
                {mobilePortfolio && (
                  <Nav.Item className="profile-settings-mobile-only">
                    <Nav.Link
                      eventKey="sixth"
                      onClick={() => handleActive("sixth")}
                    >
                      {t("Portfolio")}
                    </Nav.Link>
                  </Nav.Item>
                )}
                <Nav.Item>
                  <Nav.Link
                    eventKey="second"
                    onClick={() => handleActive("second")}
                    href="#companyDetails"
                  >
                    {t(isBrokerOrAgent ? "Broker Details" : "Company Details")}
                  </Nav.Link>
                </Nav.Item>
                {!isBrokerOrAgent && (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="third"
                      onClick={() => handleActive("third")}
                      href="#financial"
                    >
                      {t("Payments")}
                    </Nav.Link>
                  </Nav.Item>
                )}
                {!isBrokerOrAgent && (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="fifth"
                      onClick={() => handleActive("fifth")}
                      href="#recentWork"
                    >
                      {t("Recent Work")}
                    </Nav.Link>
                  </Nav.Item>
                )}

                {/* <Nav.Item>
        <Nav.Link eventKey="fourth" href="#changePassword">
          {t("Change Password")}
        </Nav.Link>
      </Nav.Item> */}
              </Nav>
            </div>
          </Row>
          <section className="profile-settings-overview-grid" aria-label={t("Profile overview")}>
            <article className="profile-settings-overview-card">
              <span className="profile-settings-overview-icon is-blue" aria-hidden="true">
                <UserCheck />
              </span>
              <div>
                <span>{t("Profile completion")}</span>
                <strong>{data?.ua_completed != null ? `${data.ua_completed}%` : t("In progress")}</strong>
              </div>
            </article>
            <article className="profile-settings-overview-card">
              <span className="profile-settings-overview-icon is-cyan" aria-hidden="true">
                <i className="bi bi-briefcase" />
              </span>
              <div>
                <span>{t("Account type")}</span>
                <strong className="text-capitalize">{userType?.replace(/_/g, " ") || t("Member")}</strong>
              </div>
            </article>
            <article className="profile-settings-overview-card">
              <span className="profile-settings-overview-icon is-green" aria-hidden="true">
                <i className="bi bi-building" />
              </span>
              <div>
                <span>{t(isBrokerOrAgent ? "Broker profile" : "Company profile")}</span>
                <strong>{companyD?.cc_company_name || t("Not added")}</strong>
              </div>
            </article>
            <article className="profile-settings-overview-card">
              <span className="profile-settings-overview-icon is-amber" aria-hidden="true">
                <i className="bi bi-shield-check" />
              </span>
              <div>
                <span>{t("Payment status")}</span>
                <strong>{isPaymentVerified ? t("Verified") : t("Not verified")}</strong>
              </div>
            </article>
          </section>
{error &&           <div
    style={{
      border: "1px solid red",
      backgroundColor: "#ffe6e6", // light red background
      color: "red",
      padding: "8px 12px",
      borderRadius: "5px",
      marginTop: "4px",
      fontSize: "14px",
      marginBottom:10
    }}
  >
{error}
  </div>}


          {/*Pricing */}
          {userType !== "real_estate_agent" && userType !== "subcontractor" ? (
            <Tab.Content>
              <Tab.Pane eventKey="fourth" id="packages">
                <Card className="profile-settings-content-card profile-settings-pricing-shell">
                  <div className="tab-pane" id="packages" role="tabpanel">
                    <Card.Body>
                      <section className="profile-settings-pricing" aria-labelledby="pricing-heading">
                        {isPackagesLoading ? (
                          <PricingSectionSkeleton />
                        ) : (
                          <>
                        <header className="profile-settings-pricing-hero">
                          <span className="profile-settings-pricing-eyebrow">
                            {t("Contract automation plans")}
                          </span>
                          <h2 id="pricing-heading">{t("Simple pricing. Serious business tools.")}</h2>
                          <p>
                            {trialEligible
                              ? t("Choose the billing schedule that works for your business. Every plan includes the complete platform and a 30-day free trial.")
                              : t("Choose the billing schedule that works for your business. Your previous subscription history makes this account ineligible for another free trial.")}
                          </p>
                          <div className="profile-settings-pricing-trust" aria-label={t("Subscription benefits")}>
                            {trialEligible ? <span><Clock3 aria-hidden="true" /> {t("30-day free trial")}</span> : null}
                            <span><ShieldCheck aria-hidden="true" /> {t("Secure payments")}</span>
                            <span><CheckCircle2 aria-hidden="true" /> {t("All features included")}</span>
                          </div>
                        </header>

                        {pendingYearlySwitch ? (
                          <div className="profile-settings-plan-change-notice" role="status">
                            <span className="profile-settings-plan-change-notice__icon" aria-hidden="true">
                              <CalendarClock />
                            </span>
                            <div>
                              <strong>{t("Yearly billing is scheduled")}</strong>
                              <span>
                                {pendingYearlySwitchDate
                                  ? `${t("Your monthly plan remains active until")} ${pendingYearlySwitchDate}. ${t("Yearly billing starts automatically at renewal.")}`
                                  : t("Your monthly plan remains active until your next renewal, when yearly billing starts automatically.")}
                              </span>
                            </div>
                          </div>
                        ) : null}

                        <div className="profile-settings-pricing-grid">
                          {pricingdata.map((plan) => {
                            const isCurrentPlan =
                              userSubscribed?.subscription?.status === "active" &&
                              userSubscribed?.subscription?.planType === plan.plan_type;
                            const canSwitchToYearly =
                              userSubscribed?.subscription?.status === "active" &&
                              userSubscribed?.subscription?.planType === "monthly" &&
                              plan.plan_type === "yearly";
                            const yearlySwitchScheduled =
                              canSwitchToYearly && userSubscribed?.pendingPlanChange?.targetPlan === "yearly";

                            return (
                              <PricingCard
                                key={plan.id}
                                plan={plan}
                                isCurrentPlan={isCurrentPlan}
                                trialEligible={trialEligible}
                                disabled={yearlySwitchScheduled}
                                actionNote={yearlySwitchScheduled
                                  ? t("Your monthly plan stays active until the scheduled renewal date")
                                  : canSwitchToYearly
                                  ? t("No charge today · Yearly billing starts at your next renewal")
                                  : undefined}
                                title={isCurrentPlan
                                  ? t("Cancel subscription")
                                  : yearlySwitchScheduled
                                  ? t("Yearly switch scheduled")
                                  : canSwitchToYearly
                                  ? t("Switch to yearly at renewal")
                                  : trialEligible
                                  ? t("Start 30-day free trial")
                                  : t("Subscribe now")}
                                onClick={() => {
                                  if (isCurrentPlan) {
                                    setAlertDetails({
                                      status: true,
                                      title: "Cancel Subscription?",
                                      message:
                                        "You’re about to cancel your subscription. Are you absolutely sure you want to do this?",
                                      icon: IoTrashOutline,
                                      button1Text: "Keep Subscription",
                                      button2Text: "Cancel Subscription",
                                      button1Style:
                                        "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
                                      button2Style:
                                        "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
                                      onButton1Click: () => {},
                                      onButton2Click: () => {
                                        handleCancelSubscription();
                                      },
                                    });
                                  } else if (canSwitchToYearly) {
                                    confirmYearlySwitch(plan);
                                  } else {
                                    handleStripePc(plan);
                                  }
                                }}
                              />
                            );
                          })}
                        </div>

                        <footer className="profile-settings-pricing-footer">
                          <div>
                            <strong>{t("Build your business profile first")}</strong>
                            <span>{t("You can complete your details before choosing a subscription.")}</span>
                          </div>
                          <Button
                            type="button"
                            onClick={() => handleActive("first")}
                            variant="link"
                            className="profile-settings-pricing-profile-link"
                          >
                            {t("Continue to profile")} <span aria-hidden="true">→</span>
                          </Button>
                        </footer>
                          </>
                        )}
                      </section>
                    </Card.Body>
                  </div>
                </Card>
              </Tab.Pane>
            </Tab.Content>
          ) : (
            ""
          )}

          {/*First */}
          <Tab.Content>
            <Tab.Pane eventKey="first" id="personalDetails">
              <Card className="profile-settings-content-card tailwind-prefix"> 
     

                <Card.Header>
                  <h6 className="card-title mb-0"> {t("Personal Details")}</h6>
                </Card.Header>
                <Card.Body>
                <div className="profile-settings-form-note">
  <div className="profile-settings-form-note-title">
    {t("Changes save automatically as you edit.")}
  </div>
  <div className="profile-settings-form-note-copy">
    {t("Email changes are locked here. Please contact support if you need to update your email address.")}
  </div>
</div>
{/* <AutoSaveInput defaultValue="" onSave={()=>{
  console.log("hii")
}}  /> */}
                  <Form
                    action="#"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                    className="profile-settings-personal-form"
                  >
                    <Row>
                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="firstName">
                            {props.t("First Name")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="firstName"
                            name="firstName"
                            placeholder={props.t("Enter your first name")}
                            required
                            onChange={(e: any) => {
                              const firstName= e.target.value
                              validation.setFieldValue(
                                "firstName",
                                firstName
                              );
                         
                                updatePersonalDetails({
                                  ...validation.values,
                                  firstName:firstName
                                },"firstName")
                             
                            }}
                            value={validation.values.firstName || ""}
                            isInvalid={
                              validation.touched.firstName &&
                              validation.errors.firstName
                                ? true
                                : false
                            }
                          />
                          <SavedFieldCheck field="firstName" />
                        </div>
                        {validation.touched.firstName &&
                        validation.errors.firstName ? (
                          <Form.Control.Feedback type="invalid">
                            {/* {validation.errors.firstName} */}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="lastName">
                            {props.t("Last Name")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="lastName"
                            name="lastName"
                            onChange={(e: any) => {
                              const lastName= e.target.value
                              validation.setFieldValue(
                                "lastName",
                                lastName
                              );
                         
                                updatePersonalDetails({
                                  ...validation.values,
                                  lastName:lastName
                                },"lastName")
                             
                            }}

                            placeholder={props.t("Enter your last name")}
                            required

                    
                            value={validation.values.lastName || ""}
                            isInvalid={
                              validation.touched.lastName &&
                              validation.errors.lastName
                                ? true
                                : false
                            }
                          />
                          <SavedFieldCheck field="lastName" />
     
                        </div>
                        {validation.touched.lastName &&
                        validation.errors.lastName ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.lastName === "string"
                              ? validation.errors.lastName
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="phoneNumber">
                            {props.t("Phone Number")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            id="phoneNumber"
                            name="phoneNumber"
                            placeholder={props.t("Enter your phone number")}
                            required
                            onChange={(e: any) => {
                              const phoneNumber= e.target.value
                              validation.setFieldValue(
                                "phoneNumber",
                                phoneNumber
                              );
                         
                                updatePersonalDetails({
                                  ...validation.values,
                                  phoneNumber:phoneNumber
                                },"phoneNumber")
                             
                            }}
                        
                            value={userFormattedPhoneNumber}
                            isInvalid={
                              validation.touched.phoneNumber &&
                              validation.errors.phoneNumber
                                ? true
                                : false
                            }
                          />
                          <SavedFieldCheck field="phoneNumber" />
                        </div>
                        {validation.touched.phoneNumber &&
                        validation.errors.phoneNumber ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.phoneNumber === "string"
                              ? validation.errors.phoneNumber
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Form.Label htmlFor="email">
                            {props.t("Email Address")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="email"
                            id="email"
                         readOnly

                            name="email"
                            placeholder={props.t("Enter your email")}
                            required
                          
                            value={validation.values.email || ""}
                            isInvalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.email && validation.errors.email ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.email === "string"
                              ? validation.errors.email
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="birthDate">
                            {props.t("Date of Birth")}
                          </Form.Label>
                          <Flatpickr
                            id="birthDate"
                            name="birthDate"
                            className="form-control"
                            options={{ dateFormat: "d M, Y" }}
                            placeholder={props.t("Select date")}
                            value={validation.values.birthDate}
                            onChange={(date:any) => {
                              validation.setFieldValue("birthDate", date[0])

                              debouncedUpdateUser({ ...validation.values, birthDate:date[0] },'birthDate');
                            }}
                         
                          />
                              {selectedInput ==="birthDate" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.birthDate &&
                            validation.touched.birthDate && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.birthDate === "string"
                                  ? validation.errors.birthDate
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="joiningDate">
                            {t("Joining Date")}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    'The joining date refers to when you started your business. For example: "I started my electrician business on 08/28/1994."'
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <Form.Control
    type="text"
    id="joiningDate"
    name="joiningDate"
   readOnly
    value={validation.values.joiningDate ? moment(validation.values.joiningDate).format("MM/DD/YYYY"): ""}
  />
                          {/* <Flatpickr
                            id="joiningDate"
                            name="joiningDate"
                            className="form-control"
                            options={{ dateFormat: "d M, Y" }}
                            placeholder={t("Select date")}
                            value={validation.values.joiningDate}
                           
                           
                          /> */}
                              {selectedInput ==="joiningDate" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.joiningDate &&
                            validation.touched.joiningDate && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.joiningDate ===
                                "string"
                                  ? validation.errors.joiningDate
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <Form.Group className="mb-3 position-relative">
                          <Form.Label htmlFor="profile" className="text-muted">
                            {t("Profession")}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    'Please select your profession here. For example, if I am an electrician, I would choose "electrician" as my profession.'
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <Select
                            id="profile"
                            name="profile"
                            classNamePrefix="profile-settings-select"
                            options={profileOptions}
                            value={validation.values.profile}
            
                            onChange={(selectedProfile: any) => {
                              handleProfileOnchange(selectedProfile).then(()=>{
                                  updatePersonalDetails({
                                    ...validation.values,
                                    profile:selectedProfile
                                  },"profile")
                              })
                          
                           
                                    
                            }}
                          />
                          <SavedFieldCheck field="profile" />
                          {validation.errors.profile &&
                            validation.touched.profile && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.profile === "string"
                                  ? validation.errors.profile
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group className="mb-3 position-relative">
                          <Form.Label htmlFor="skills" className="text-muted">
                            {t("Skills(Type the skills and press enter)")}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    "Please select the skills you possess. For example, as an electrician, I might choose skills like Basement Rewiring and Electrical Renovation."
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <CreatableSelect
                            id="skills"
                            name="skills"
                            classNamePrefix="profile-settings-select"
                            options={userSkills}
                            isMulti
                            value={selectedOptions}
                            onChange={(selected: any) => {
                              handleSelectedOptionsChange(selected);
                              updatePersonalDetails({ ...validation.values, skills: selected },"skills");
                               
                            }}
                          />
                          <SavedFieldCheck field="skills" />
                          {validation.errors.skills &&
                            validation.touched.skills && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.skills === "string"
                                  ? validation.errors.skills
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </Form.Group>
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Group className="mb-3 position-relative">
                            <Form.Label htmlFor="workAvailability">
                              {t("Work Availability")}
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">
                                    {t(
                                      "In this please select if you are available for work full time or part time only."
                                    )}
                                  </Tooltip>
                                }
                              >
                                <Button className="infoButton">?</Button>
                              </OverlayTrigger>
                            </Form.Label>
                            <Select
                              id="workAvailability"
                              name="workAvailability"
                              classNamePrefix="profile-settings-select"
                              options={workAvailable}
                              value={validation.values.workAvailability}
                              
                              onChange={(selectedWorkAvail: any) => {
                                validation.setFieldValue(
                                  "workAvailability",
                                  selectedWorkAvail
                                );
                           
                                  updatePersonalDetails({
                                    ...validation.values,
                                    workAvailability:selectedWorkAvail
                                  },"workAvailability")
                               
                              }}

                          
                            />
                            <SavedFieldCheck field="workAvailability" />
                            {validation.errors.workAvailability &&
                              validation.touched.workAvailability && (
                                <Form.Control.Feedback type="invalid">
                                  {typeof validation.errors.workAvailability ===
                                  "string"
                                    ? validation.errors.workAvailability
                                    : ""}
                                </Form.Control.Feedback>
                              )}
                          </Form.Group>
                        </div>
                      </Col>

                      <Col lg={4}>
                      <div className="mb-3 position-relative">
  <Form.Label htmlFor="experience">
    {t("Experience (In Years)")} <RequiredMark />
  </Form.Label>
  <Form.Control
    type="text"
    id="experience"
    name="experience"
    required
    onChange={(e) => {
      validation.handleChange(e);
      debouncedUpdateUser({ ...validation.values, experience: e.target.value },e.target.name);
    }}
    value={validation.values.experience || ""}
    isInvalid={validation.touched.experience && validation.errors.experience ? true : false}
  />
  <SavedFieldCheck field="experience" />
</div>

                        {validation.touched.experience &&
                        validation.errors.experience ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.experience === "string"
                              ? validation.errors.experience
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="workHours">
                            {t("Work Hours")} <RequiredMark />
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    'Please enter your work hours. For example, "I am available for work from 2 PM to 6 PM."'
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="workHours"
                            name="workHours"
                            required
                            onChange={(e) => {
                              validation.handleChange(e);
                              debouncedUpdateUser({ ...validation.values, workHours: e.target.value },e.target.name);
                            }}
                            value={validation.values.workHours || ""}
                            isInvalid={
                              validation.touched.workHours &&
                              validation.errors.workHours
                                ? true
                                : false
                            }
                          />
                            {selectedInput ==="workHours" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                        </div>
                        {validation.touched.workHours &&
                        validation.errors.workHours ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.workHours === "string"
                              ? validation.errors.workHours
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3 position-relative">
                          <Form.Label htmlFor="zipcodeInput">
                            {t("Zip Code")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="text"
                            minLength={5}
                            maxLength={6}
                            id="zipcodeInput"

                            name="zipcodeInput"
                            placeholder={t("Enter zipcode")}
                            required
                            onChange={(e) => {
                              validation.handleChange(e);
                              if (e.target.value.length === 5) {
                                getData(e.target.value);
                            

                              }
                            }}
               
                            value={validation.values.zipcodeInput || ""}
                            isInvalid={
                              validation.touched.zipcodeInput &&
                              validation.errors.zipcodeInput
                                ? true
                                : false
                            }
                          />
                          <SavedFieldCheck field="zipcodeInput" />
                        </div>
                        {zipcodeError && <div className="text-red-500 -mt-4 text-sm mb-2 ">
                          {zipcodeError}  </div>}
                        {validation.touched.zipcodeInput &&
                        validation.errors.zipcodeInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.zipcodeInput === "string"
                              ? t(validation.errors.zipcodeInput)
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Label htmlFor="cityInput">
                            {t("City")} <RequiredMark />
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="cityInput"
                            name="cityInput"
                            placeholder={t("City")}
                            required
                            readOnly
                        
                            value={validation.values.cityInput || ""}
                            isInvalid={
                              validation.touched.cityInput &&
                              validation.errors.cityInput
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.cityInput &&
                        validation.errors.cityInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.cityInput === "string"
                              ? validation.errors.cityInput
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Label htmlFor="userState">
                            {t("State")}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="userState"
                            name="userState"
                            placeholder={t("State")}
                            required
                            readOnly
                      
                            value={validation.values.userState || ""}
                            isInvalid={
                              validation.touched.userState &&
                              validation.errors.cityInput
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.userState &&
                        validation.errors.userState ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.userState === "string"
                              ? validation.errors.userState
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Label htmlFor="countryInput">
                            {t("Country")}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            id="countryInput"
                            name="countryInput"
                            placeholder={t("Country")}
                            required
                           readOnly
                            value={
                              validation.values.countryInput ||
                              t("United States")
                            }
                            disabled
                            isInvalid={
                              validation.touched.countryInput &&
                              validation.errors.countryInput
                                ? true
                                : false
                            }
                          />
                        </div>
                        {validation.touched.countryInput &&
                        validation.errors.countryInput ? (
                          <Form.Control.Feedback type="invalid">
                            {typeof validation.errors.countryInput === "string"
                              ? validation.errors.countryInput
                              : ""}
                          </Form.Control.Feedback>
                        ) : null}
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3 pb-2 position-relative">
                          <Form.Label htmlFor="address">
                            {t("Address")} <RequiredMark />
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    "Please provide your residential address here, not your shop address."
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            id="address"
                            name="address"
                            required
                            placeholder={t("Enter your address")}
                            value={validation.values.address || ""}
                            onChange={(e) => {
                              validation.handleChange(e);
                              debouncedUpdateUser({ ...validation.values, address: e.target.value },e.target.name);
                            }}
                            isInvalid={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                          />
                            {selectedInput ==="address" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.address &&
                            validation.touched.address && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.address === "string"
                                  ? t(validation.errors.address)
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="mb-3 pb-2 position-relative">
                          <Form.Label htmlFor="descpription">
                            {t("Describe Yourself")} <RequiredMark />
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top">
                                  {t(
                                    "Please write about yourself, highlighting your talents, specialties, and the reasons why homeowners should choose you."
                                  )}
                                </Tooltip>
                              }
                            >
                              <Button className="infoButton">?</Button>
                            </OverlayTrigger>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            id="descpription"
                            name="descpription"
                            required
                            placeholder={t("Enter your description")}
                            value={validation.values.descpription || ""}
                            onChange={(e) => {
                              validation.handleChange(e);
                              debouncedUpdateUser({ ...validation.values, descpription: e.target.value },"descpription");
                            }}
                            isInvalid={
                              validation.touched.descpription &&
                              validation.errors.descpription
                                ? true
                                : false
                            }
                          />
                            {selectedInput ==="descpription" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                          {validation.errors.descpription &&
                            validation.touched.descpription && (
                              <Form.Control.Feedback type="invalid">
                                {typeof validation.errors.descpription ===
                                "string"
                                  ? t(validation.errors.descpription)
                                  : ""}
                              </Form.Control.Feedback>
                            )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-between flex-wrap">
                          <span className="profile-settings-save-hint">
                            {t("Saved fields show a checkmark after updating.")}
                          </span>
                          <Button type="submit" variant="primary">
                            {t(
                              isBrokerOrAgent
                                ? "Continue to Broker Details"
                                : "Submit"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Tab.Pane>
          </Tab.Content>
          {/*Second */}
          {mobilePortfolio && (
            <Tab.Content className="profile-settings-mobile-only">
              <Tab.Pane eventKey="sixth" id="mobilePortfolio">
                <Card className="profile-settings-content-card">
                  {mobilePortfolio}
                </Card>
              </Tab.Pane>
            </Tab.Content>
          )}

          <Tab.Content style={{
            flex:1
          }} className="tailwind-prefix ">
            <Tab.Pane eventKey="second" id="companyDetails">
              {/* <Card>
                <Card.Body>
                    <Row>
                      <Col lg={12}>
                       <div className="form-check form-switch form-check-right">
                <Form.Check type="switch" role="switch" id="isRegistered" onChange={(e)=>isRegistered(e)} style={{fontSize:'16px', marginBottom:0}} />
                <Form.Label htmlFor="isRegistered" style={{fontSize:'16px', marginBottom:0}}>If you don't have a registered company, please check the box.</Form.Label>
            </div>
                      </Col>
                    </Row>
                </Card.Body>
              </Card> */}
              <Card className="profile-settings-content-card profile-settings-company-card">
                <div className="profile-settings-company-hero">
                  <div className="profile-settings-company-hero-main">
                    <span className="profile-settings-company-hero-icon" aria-hidden="true">
                      <i className="ri-building-4-line" />
                    </span>
                    <div>
                      <span className="profile-settings-company-eyebrow">
                        {t(isBrokerOrAgent ? "Broker settings" : "Company settings")}
                      </span>
                      <h2>
                        {t(
                          isBrokerOrAgent
                            ? "Broker profile"
                            : "Company profile"
                        )}
                      </h2>
                      <p>
                        {t(
                          "Add the business details and documents homeowners need to recognize and trust your company."
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="profile-settings-company-save-state">
                    <span className="profile-settings-company-save-dot" />
                    {t("Auto-save is on")}
                  </div>
                </div>
                <Card.Body className="profile-settings-company-body">
                  <div className="profile-settings-company-layout">
                    <aside className="profile-settings-company-summary" aria-label="Business profile progress">
                      <div className="profile-settings-company-brand">
                        <div className="profile-settings-company-avatar">
                          {compLogo ? (
                            <img src={compLogo} alt="Company logo" />
                          ) : (
                            <span>{String(companyValidation.values.companyName || company_broker).charAt(0).toUpperCase()}</span>
                          )}
                        </div>
                        <div>
                          <strong>{companyValidation.values.companyName || `Your ${company_broker.toLowerCase()}`}</strong>
                          <span>{companyValidation.values.companyCity && companyValidation.values.companyState ? `${companyValidation.values.companyCity}, ${companyValidation.values.companyState}` : "Business profile"}</span>
                        </div>
                      </div>

                      <div className="profile-settings-company-progress-block">
                        <div
                          className="profile-settings-company-progress-ring"
                          style={{ background: `conic-gradient(#2563eb ${companyProfilePercent}%, #e5edf5 ${companyProfilePercent}% 100%)` }}
                          aria-label={`${companyProfilePercent}% complete`}
                        >
                          <span className="text-center flex items-center justify-center">{companyProfilePercent}%</span>
                        </div>
                        <div>
                          <strong>{t("Profile readiness")}</strong>
                          <span>{companyProfilePercent === 100 ? t("Ready to publish") : t("Complete the remaining items")}</span>
                        </div>
                      </div>

                      <div className="profile-settings-company-checklist">
                        <div className={hasBusinessContact ? "is-complete" : ""}>
                          <i className={hasBusinessContact ? "ri-checkbox-circle-fill" : "ri-checkbox-blank-circle-line"} />
                          <span>{t("Business contact")}</span>
                        </div>
                        <div className={hasBusinessLocation ? "is-complete" : ""}>
                          <i className={hasBusinessLocation ? "ri-checkbox-circle-fill" : "ri-checkbox-blank-circle-line"} />
                          <span>{t("Business location")}</span>
                        </div>
                        <div className={Boolean(compLogo) ? "is-complete" : ""}>
                          <i className={compLogo ? "ri-checkbox-circle-fill" : "ri-checkbox-blank-circle-line"} />
                          <span>{t("Company logo")}</span>
                        </div>
                        <div className={hasComplianceDocuments ? "is-complete" : ""}>
                          <i className={hasComplianceDocuments ? "ri-checkbox-circle-fill" : "ri-checkbox-blank-circle-line"} />
                          <span>{t("Compliance documents")}</span>
                        </div>
                      </div>

                      <nav className="profile-settings-company-jump" aria-label="Company profile sections">
                        <a href="#company-identity"><i className="ri-building-line" />{t("Business identity")}</a>
                        <a href="#company-location"><i className="ri-map-pin-2-line" />{t("Location")}</a>
                        <a href="#company-brand"><i className="ri-image-line" />{t("Brand & media")}</a>
                        <a href="#company-documents"><i className="ri-shield-check-line" />{t("Verification")}</a>
                      </nav>
                    </aside>

                    <div className="profile-settings-company-editor">
                  <Form
                    className="profile-settings-company-form"
                    action="#"
                    onSubmit={(e) => {
                      e.preventDefault();
                      companyValidation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row className="g-3">
                      <Col lg={12}>
                        <div className="profile-settings-company-section-heading" id="company-identity">
                          <span><i className="ri-building-line" /></span>
                          <div>
                            <h3>{t(isBrokerOrAgent ? "Broker identity" : "Business identity")}</h3>
                            <p>{t("Information customers use to recognize and contact your business.")}</p>
                          </div>
                        </div>
                      </Col>
                      {showCompany ? (
                        <>
                          <Col lg={6}>
                            <div className="mb-3 position-relative">
                              <Form.Label htmlFor="companyName">
                                {t(
                                  isBrokerOrAgent
                                    ? "Broker Name"
                                    : "Company Name"
                                )}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {t(
                                        isBrokerOrAgent
                                          ? "Please enter broker name."
                                          : "Please enter your company name. For example: Trident Electricals."
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <Button className="infoButton">?</Button>
                                </OverlayTrigger>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="companyName"
                                name="companyName"
                                placeholder={t(
                                  isBrokerOrAgent
                                    ? "Enter broker name"
                                    : "Enter your company name"
                                )}
                                onChange={(e) => {
                                  companyValidation.handleChange(e);
                                  debouncedUpdateCompany({ ...companyValidation.values, companyName: e.target.value },false, e.target.name);
                                }}
                                value={
                                  companyValidation.values.companyName || ""
                                }
                                isInvalid={
                                  companyValidation.touched.companyName &&
                                  companyValidation.errors.companyName
                                    ? true
                                    : false
                                }
                              />
                                                          {selectedInput ==="companyName" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
     
                            </div>
                            {companyValidation.touched.companyName &&
                            companyValidation.errors.companyName ? (
                              <Form.Control.Feedback type="invalid">
                                {typeof companyValidation.errors.companyName ===
                                "string"
                                  ? t(companyValidation.errors.companyName)
                                  : ""}
                              </Form.Control.Feedback>
                            ) : null}
                          </Col>

                          {!isBrokerOrAgent && (companyValidation.values.companyState === "OH" || Boolean(companyValidation.values.federalTaxId)) && (
                            <Col lg={6}>
                              <div className="mb-3 position-relative">
                                <Form.Label htmlFor="federalTaxId">
                                  {t("Federal Tax ID / EIN")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="federal-tax-id-help">{t("Required for Ohio home improvement contracts. Enter the 9 digits without a dash.")}</Tooltip>}
                                  >
                                    <Button className="infoButton">?</Button>
                                  </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                  type="password"
                                  inputMode="numeric"
                                  autoComplete="off"
                                  id="federalTaxId"
                                  name="federalTaxId"
                                  maxLength={9}
                                  placeholder={t("Enter 9-digit EIN")}
                                  value={companyValidation.values.federalTaxId || ""}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "").slice(0, 9);
                                    companyValidation.setFieldValue("federalTaxId", value);
                                    if (value.length === 9) {
                                      debouncedUpdateCompany({ ...companyValidation.values, federalTaxId: value }, false, "federalTaxId");
                                    }
                                  }}
                                  isInvalid={Boolean(companyValidation.touched.federalTaxId && companyValidation.errors.federalTaxId)}
                                />
                                {companyValidation.touched.federalTaxId && companyValidation.errors.federalTaxId ? (
                                  <Form.Control.Feedback type="invalid">
                                    {String(companyValidation.errors.federalTaxId)}
                                  </Form.Control.Feedback>
                                ) : null}
                              </div>
                            </Col>
                          )}

                          <Col lg={6}>
                            {!isBrokerOrAgent && (
                              <div className="mb-3 position-relative">
                                <Form.Label htmlFor="companyRegisterdNumber">
                                  {t("License Number")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        {t(
                                          "Please enter your company registration number. For example: RMZ1234556."
                                        )}
                                      </Tooltip>
                                    }
                                  >
                                    <Button className="infoButton">?</Button>
                                  </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  id="companyRegisterdNumber"
                                  name="companyRegisterdNumber"
                                  placeholder={t(
                                    "Enter your company registered number"
                                  )}
                                  onChange={(e) => {
                                    companyValidation.handleChange(e);
                                    debouncedUpdateCompany({ ...companyValidation.values, companyRegisterdNumber: e.target.value }, false,"companyRegisterdNumber");
                                  }}
                                  value={
                                    companyValidation.values
                                      .companyRegisterdNumber || ""
                                  }
                                  isInvalid={
                                    companyValidation.touched
                                      .companyRegisterdNumber &&
                                    companyValidation.errors
                                      .companyRegisterdNumber
                                      ? true
                                      : false
                                  }
                                />
                            
                                                            {selectedInput ==="companyRegisterdNumber" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
     
                              </div>
                            )}

                            {companyValidation.touched.companyRegisterdNumber &&
                            companyValidation.errors.companyRegisterdNumber ? (
                              <Form.Control.Feedback type="invalid">
                                {typeof companyValidation.errors
                                  .companyRegisterdNumber === "string"
                                  ? t(
                                      companyValidation.errors
                                        .companyRegisterdNumber
                                    )
                                  : ""}
                              </Form.Control.Feedback>
                            ) : null}
                          </Col>

                          <Col lg={6}>
                            <div className="mb-3 position-relative">
                              <Form.Label htmlFor="companyPhoneNumber">
                                {t(
                                  isBrokerOrAgent
                                    ? "Broker Phone Number"
                                    : "Company Phone Number"
                                )}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {t(
                                        isBrokerOrAgent
                                          ? "Please enter broker phone number."
                                          : "Please enter your company phone number. If you don’t have a company number, you can provide your personal number instead. For example: 123-456-2929."
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <Button className="infoButton">?</Button>
                                </OverlayTrigger>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="companyPhoneNumber"
                                name="companyPhoneNumber"

                                placeholder={t(
                                  isBrokerOrAgent
                                    ? "Enter broker phone number"
                                    : "Enter your company phone number"
                                )}
                                onChange={(e:any)=>{
                                  handleCompanyPhoneNumberChange(e)
                                }}
                                maxLength={10}
                                value={formattedPhoneNumber}
                                isInvalid={
                                  companyValidation.touched
                                    .companyPhoneNumber &&
                                  companyValidation.errors.companyPhoneNumber
                                    ? true
                                    : false
                                }
                              />
                                                              {selectedInput ==="companyPhoneNumber" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
     
                            </div>
                        {companyPhoneErr && <div className="text-red-500 -mt-4 text-sm mb-2">
                          {companyPhoneErr}
                          </div>}
                          </Col>

                          <Col lg={6}>
                            <div className="mb-3 position-relative">
                              <Form.Label htmlFor="companyEmail">
                                {t(
                                  isBrokerOrAgent
                                    ? "Broker Email Address"
                                    : "Company Email Address"
                                )}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {t(
                                        "Please enter your work email address. For example: info@tredentelectric.com."
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <Button className="infoButton">?</Button>
                                </OverlayTrigger>
                              </Form.Label>
                              <Form.Control
                                type="email"
                                id="companyEmail"
                                name="companyEmail"
                                placeholder={t(
                                  isBrokerOrAgent
                                    ? "Enter broker email"
                                    : "Enter your company email"
                                )}
                                onChange={(e) => {
                                  if(emailRegex.test(e.target.value)){
                                    setCompanyEmailErr("")

                                  }else{
                                    setCompanyEmailErr("Invalid or incomplete email format")
                                  }
                                  debouncedUpdateCompany({ ...companyValidation.values, companyEmail: e.target.value },true, e.target.name);

                                  companyValidation.handleChange(e);

                                }}
                                value={
                                  companyValidation.values.companyEmail || ""
                                }
                                isInvalid={
                                  companyValidation.touched.companyEmail &&
                                  companyValidation.errors.companyEmail
                                    ? true
                                    : false
                                }

                              />
                                                          {selectedInput ==="companyEmail" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
     
                         
                            </div>
                            {companyEmailErr && <div className="text-red-500 -mt-4 text-sm mb-2">
                          {companyEmailErr}
                          </div>}
                        
                          </Col>

                          {!isBrokerOrAgent && (
                            <Col lg={12}>
                              <div className="mb-3 position-relative">
                                <Form.Label htmlFor="JoiningdatInput">
                                  {t("Company's date of incorporation")}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        {t(
                                          "Please enter your company registration date."
                                        )}
                                      </Tooltip>
                                    }
                                  >
                                    <Button className="infoButton">?</Button>
                                  </OverlayTrigger>
                                </Form.Label>
                                <Flatpickr
                                  className="form-control"
                                  id="companyRegisterdDate"
                                  name="companyRegisterdDate"
                                  options={{ dateFormat: "d M, Y" }}
                                  placeholder={t("Select date")}
                                  value={
                                    companyValidation.values
                                      .companyRegisterdDate
                                  }
                         
                                  onChange={(date: any) =>{
                                    companyValidation.setFieldValue(
                                      "companyRegisterdDate",
                                      date[0]
                                    )
                                    updateCompanyDetails({ ...companyValidation.values, companyRegisterdDate: date[0]},"companyRegisterdDate");
   }
                                  
                                  }
                                />
                                                    {selectedInput ==="companyRegisterdDate" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                                {companyValidation.errors
                                  .companyRegisterdDate &&
                                  companyValidation.touched
                                    .companyRegisterdDate && (
                                    <Form.Control.Feedback type="invalid">
                                      {typeof companyValidation.errors
                                        .companyRegisterdDate === "string"
                                        ? t(
                                            companyValidation.errors
                                              .companyRegisterdDate
                                          )
                                        : ""}
                                    </Form.Control.Feedback>
                                  )}
                              </div>
                            </Col>
                          )}

                          <Col lg={12}>
                            <div className="profile-settings-company-section-heading is-subsection" id="company-location">
                              <span><i className="ri-map-pin-2-line" /></span>
                              <div>
                                <h3>{t("Business location")}</h3>
                                <p>{t("Use the primary address where your company operates or receives business mail.")}</p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <div className="position-relative">
                              <Form.Label htmlFor="companyAddress">
                                {t(`Company Address`)}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {t(
                                        `Please add Company address or shop address.`
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <Button className="infoButton">?</Button>
                                </OverlayTrigger>
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                id="companyAddress"
                                name="companyAddress"
                                placeholder={t("Enter your address")}
                                value={
                                  companyValidation.values.companyAddress || ""
                                }
                                onChange={(e: any) =>{
                                  companyValidation.setFieldValue(
                                    "companyAddress",
                                    e.target.value
                                  )
                                  updateCompanyDetails({ ...companyValidation.values, companyAddress: e.target.value},e.target.name);
 }}
                                isInvalid={
                                  companyValidation.touched.companyAddress &&
                                  companyValidation.errors.companyAddress
                                    ? true
                                    : false
                                }
                              />
                                                        {selectedInput ==="companyAddress" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                              {companyValidation.errors.companyAddress &&
                                companyValidation.touched.companyAddress && (
                                  <Form.Control.Feedback type="invalid">
                                    {typeof companyValidation.errors
                                      .companyAddress === "string"
                                      ? t(
                                          companyValidation.errors
                                            .companyAddress
                                        )
                                      : ""}
                                  </Form.Control.Feedback>
                                )}
                            </div>
                          </Col>
                          <Col lg={6} className="mt-3 ">
                            <div className="position-relative">
                              <Form.Label htmlFor="companyZip">
                                {t("Zip Code")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                minLength={5}
                                maxLength={6}
                                id="companyZip"
                                name="companyZip"
                                placeholder={t("Enter zipcode")}
                                value={
                                  companyValidation.values.companyZip || ""
                                }
                                onChange={(e) => {
                                  companyValidation.handleChange(e);
                                  if (e.target.value.length === 5) {
                                    getData(e.target.value, true);
                                  }
                                }}
                            
                                isInvalid={
                                  companyValidation.touched.companyZip &&
                                  companyValidation.errors.companyZip
                                    ? true
                                    : false
                                }
                              />
                                                       {selectedInput ==="companyZip" && (
   
   <i className="bi bi-check-circle-fill" style={{
position: "absolute",
right: "10px",
top: "47px",
transform: "translateY(-50%)",
color: "green",
fontSize: "1.2rem",
}} />
)}
                              {companyValidation.errors.companyZip &&
                                companyValidation.touched.companyZip && (
                                  <Form.Control.Feedback type="invalid">
                                    {typeof companyValidation.errors
                                      .companyZip === "string"
                                      ? t(companyValidation.errors.companyZip)
                                      : ""}
                                  </Form.Control.Feedback>
                                )}
                         
                            </div>
                            {zipcodeError && <div className="text-red-500  text-sm ">
                          {zipcodeError}
                          </div>}
                          </Col>

                          <Col lg={6} className="mt-3">
                            <div className="">
                              <Form.Label htmlFor="companyCity">
                                {t("City")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="companyCity"
                                disabled
                                name="companyCity"
                                placeholder={t("City")}
                                value={
                                  companyValidation.values.companyCity || ""
                                }
                                readOnly
                                isInvalid={
                                  companyValidation.touched.companyCity &&
                                  companyValidation.errors.companyCity
                                    ? true
                                    : false
                                }
                              />
                              {companyValidation.errors.companyCity &&
                                companyValidation.touched.companyCity && (
                                  <Form.Control.Feedback type="invalid">
                                    {typeof companyValidation.errors
                                      .companyCity === "string"
                                      ? t(companyValidation.errors.companyCity)
                                      : ""}
                                  </Form.Control.Feedback>
                                )}
                            </div>
                          </Col>
                          <Col lg={6} className="mt-3">
                            <div className="">
                              <Form.Label htmlFor="companyCity">
                                {t("State")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="companyState"
                                disabled
                                name="companyState"
                                placeholder={t("State")}
                                value={
                                  companyValidation.values.companyState || ""
                                }
                              readOnly
                                isInvalid={
                                  companyValidation.touched.companyState &&
                                  companyValidation.errors.companyState
                                    ? true
                                    : false
                                }
                              />
                              {companyValidation.errors.companyState &&
                                companyValidation.touched.companyState && (
                                  <Form.Control.Feedback type="invalid">
                                    {typeof companyValidation.errors
                                      .companyState === "string"
                                      ? t(companyValidation.errors.companyState)
                                      : ""}
                                  </Form.Control.Feedback>
                                )}
                            </div>
                          </Col>
                          <Col lg={6} className="mt-3">
                            <div className="">
                              <Form.Label htmlFor="companyCountry">
                                {t("Country")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="companyCountry"
                                name="companyCountry"
                                placeholder={t("Country")}
                                value={
                                  companyValidation.values.companyCountry ||
                                  t("United States")
                                }
                               readOnly
                                isInvalid={
                                  companyValidation.touched.companyCountry &&
                                  companyValidation.errors.companyCountry
                                    ? true
                                    : false
                                }
                              />
                              {companyValidation.errors.companyCountry &&
                                companyValidation.touched.companyCountry && (
                                  <Form.Control.Feedback type="invalid">
                                    {typeof companyValidation.errors
                                      .companyCountry === "string"
                                      ? t(
                                          companyValidation.errors
                                            .companyCountry
                                        )
                                      : ""}
                                  </Form.Control.Feedback>
                                )}
                            </div>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}

                      <Col lg={12}>
                        <div className="profile-settings-company-section-heading" id="company-brand">
                          <span><i className="ri-image-line" /></span>
                          <div>
                            <h3>{t("Brand & media")}</h3>
                            <p>{t("Add polished visuals that help homeowners recognize your business.")}</p>
                          </div>
                        </div>
                      </Col>

                      {!isBrokerOrAgent && (
                        <Col lg={12} className="profile-settings-company-media-block">
                          <Form.Label className="profile-settings-upload-label">
                            {t(
                              "Corporate Video"
                            )}
                          </Form.Label>
                          <p className="profile-settings-upload-copy">
                            {t(
                              "Upload a short company video to build trust with homeowners. Free videos can be up to 30 seconds."
                            )}
                          </p>
                          {profileVideo ? (
                            <UploadedPreview
                              src={profileVideo}
                              type="video"
                              showDelete={companyD && companyD.cc_video_url != null}
                              onDelete={() => deletDoc("profileVideo")}
                              isDeleting={deletingDocumentType === "profileVideo"}
                            />
                          ) : (
                            <Dropzone
                              onDrop={(acceptedFiles: any) => {
                                handleProfileVideoChange(acceptedFiles);
                              }}
                              accept={{
                                "video/*": [], // 💡 Only allows video MIME types
                              }}
                              maxFiles={1} // optional: allow only 1 video
                            >
                              {({ getRootProps, getInputProps }: any) => (
                                <div
                                  className="profile-settings-upload-zone dropzone course-dropzone border border-1 border-dashed text-center"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="dz-message needsclick">
                                    <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h4>
                                      {t(
                                        "Drop a video here or click to upload"
                                      )}
                                    </h4>
                                    <p className="profile-settings-upload-help">
                                      {t("Video files only. Free limit: 30 seconds.")}
                                    </p>
                                  </div>
                                  {profileVidLoading && (
                                    <div className="text-center mt-2">
                                      <Spinner
                                        animation="border"
                                        role="status"
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </Dropzone>
                          )}
                        </Col>
                      )}

                      <Col lg={12} className="profile-settings-company-media-block">
                        <Form.Label className="profile-settings-upload-label">
                          {t(`${company_broker} Logo`)}
                        </Form.Label>
                        <p className="profile-settings-upload-copy">
                          {t("Use a clear, high-resolution logo for your public business profile.")}
                        </p>
                        {compLogo ? (
                          <UploadedPreview
                            src={compLogo}
                            variant="logo"
                            onDelete={() => deletDoc("companyLogo")}
                            isDeleting={deletingDocumentType === "companyLogo"}
                          />
                        ) : (
                          <Dropzone
                            onDrop={(acceptedFiles: any) =>
                              handleCompanyLogoChange(acceptedFiles)
                            }
                            accept={PROFILE_IMAGE_ACCEPT}
                          >
                            {({ getRootProps, getInputProps }: any) => (
                              <div
                                className="profile-settings-upload-zone dropzone course-dropzone border border-1 border-dashed text-center"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="dz-message needsclick">
                                  <div className="mb-3">
                                    <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                  </div>
                                  <h4>{t("Drop logo here")}</h4>
                                  <p className="profile-settings-upload-help">
                                    {t("PNG, JPG, or JPEG works best.")}
                                  </p>
                                </div>
                                {compLogoLoading && (
                                  <div className="text-center mt-2">
                                    <Spinner animation="border" role="status" />
                                  </div>
                                )}
                              </div>
                            )}
                          </Dropzone>
                        )}
                      </Col>

                      <Col lg={12}>
                        <div className="profile-settings-company-section-heading" id="company-documents">
                          <span><i className="ri-shield-check-line" /></span>
                          <div>
                            <h3>{t("Compliance & verification")}</h3>
                            <p>{t("Keep credentials current so your profile stays trusted and ready for new work.")}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={12}>
                        {isComplianceContractor && (
                          <ContractorCompliancePanel
                            onDocumentUpload={(type, file) => onFileChange(type, file)}
                            onInsuranceAnswerChange={setInsuranceAnswer}
                            uploadingDocumentType={complianceUploadingType || (identityLoading ? "identity" : null)}
                          />
                        )}
                        {!isComplianceContractor && (
                        <div className="profile-settings-documents-grid">
                      {!isBrokerOrAgent && insuranceAnswer === "yes" && (
                        <div className="profile-settings-document-item" id="company-insurance-upload">
                          <Form.Label className="profile-settings-upload-label">
                            {t("Insurance Document")}
                          </Form.Label>
                          {insuranceImage ? (
                            <UploadedPreview
                              src={insuranceImage}
                              title={t("Insurance Document")}
                              document
                              onDelete={() => deletDoc("insuranceDocumentation")}
                              isDeleting={deletingDocumentType === "insuranceDocumentation"}
                            />
                          ) : (
                            <Dropzone
                              accept={PROFILE_IMAGE_ACCEPT}
                              onDrop={(acceptedFiles: any) => {
                                handleInsuranceImageChange(acceptedFiles);
                              }}
                            >
                              {({ getRootProps, getInputProps }: any) => (
                                <div
                                  className="profile-settings-upload-zone dropzone course-dropzone border border-1 border-dashed text-center"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="dz-message needsclick">
                                    <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h4>{t("Drop insurance file here")}</h4>
                                    <p className="profile-settings-upload-help">
                                      {t("PNG, JPG, or JPEG. Max size: 15 MB.")}
                                    </p>
                                  </div>
                                  {insuranceLoading && (
                                    <div className="text-center mt-2">
                                      <Spinner
                                        animation="border"
                                        role="status"
                                      />
                                    </div>
                                  )
                                  }
                                </div>
                              )}
                            </Dropzone>
                          )}
                        </div>
                      )}

                      <div className="profile-settings-document-item" id="company-w9-upload">
                        <Form.Label className="profile-settings-upload-label">
                          {t(`W9 Document`)}
                        </Form.Label>
                        {licenceImage ? (
                          <UploadedPreview
                            src={licenceImage}
                            title={t("W9 Document")}
                            document
                            onDelete={() => deletDoc("licenceDocumentation")}
                            isDeleting={deletingDocumentType === "licenceDocumentation"}
                          />
                        ) : (
                          <Dropzone
                            accept={PROFILE_IMAGE_ACCEPT}
                            onDrop={(acceptedFiles: any) => {
                              setIsLicenceUploading(true);
                              handleCompanyLicenceImageChange(acceptedFiles);
                            }}
                          >
                            {({ getRootProps, getInputProps }: any) => (
                              <div
                                className="profile-settings-upload-zone dropzone course-dropzone border border-1 border-dashed text-center"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="dz-message needsclick">
                                  <div className="mb-3">
                                    <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                  </div>
                                  <h4>{t("Drop W9 file here")}</h4>
                                  <p className="profile-settings-upload-help">
                                    {t("PNG, JPG, or JPEG. Avoid special characters in the file name.")}
                                  </p>
                                </div>
                                {companyLicLoading && (
                                  <div className="text-center mt-2">
                                    <Spinner animation="border" role="status" />
                                  </div>
                                )}
                              </div>
                            )}
                          </Dropzone>
                        )}
                      </div>

                      {!isBrokerOrAgent && (
                        <div className="profile-settings-document-item" id="company-license-upload">
                          <Form.Label className="profile-settings-upload-label">
                            {t(`Contractor License Document`)}
                          </Form.Label>
                          {contractorLicenceImage ? (
                            <UploadedPreview
                              src={contractorLicenceImage}
                              title={t("Contractor License Document")}
                              document
                              onDelete={() => deletDoc("contractorLicence")}
                              isDeleting={deletingDocumentType === "contractorLicence"}
                            />
                          ) : (
                            <Dropzone
                              accept={PROFILE_IMAGE_ACCEPT}
                              onDrop={(acceptedFiles: any) =>
                                handleContractorLicenceImageChange(
                                  acceptedFiles
                                )
                              }
                              disablePreview={true}
                            >
                              {({ getRootProps, getInputProps }: any) => (
                                <div
                                  className="profile-settings-upload-zone dropzone course-dropzone border border-1 border-dashed text-center"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="dz-message needsclick">
                                    <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h4>{t("Drop license file here")}</h4>
                                    <p className="profile-settings-upload-help">
                                      {t("PNG, JPG, or JPEG.")}
                                    </p>
                                  </div>
                                  {contLicLoading && (
                                    <div className="text-center mt-2">
                                      <Spinner
                                        animation="border"
                                        role="status"
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </Dropzone>
                          )}
                        </div>
                      )}

                        </div>
                        )}
                      </Col>

                      { 
                        <Col lg={12}>
                        <div className="profile-settings-company-action-bar">
                          <span className="profile-settings-save-hint">
                            <i className="ri-lock-2-line" />
                            {t("Fields save automatically. Documents upload immediately after selection.")}
                          </span>
                          <Button
                            type={isBrokerOrAgent ? "submit" : "button"}
                            variant="primary"
                          >
                            {t(
                              isBrokerOrAgent
                                ? "Save Broker Details"
                                : "Continue"
                            )}
                          </Button>
                        </div>
                      </Col>
                      }
                    </Row>
                  </Form>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Tab.Pane>
          </Tab.Content>
          {/*Third */}
          <Tab.Content>
            <Tab.Pane eventKey="third" id="financial">
              <Card className="profile-settings-content-card">
                <Card.Header>
                  <h6 className="card-title mb-0">
                    {t("Payments")}{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">
                          {t(
                            "Manage saved cards for lead payments and subscription actions. Card information is handled by the payment provider."
                          )}
                        </Tooltip>
                      }
                    >
                      <Button className="infoButton">?</Button>
                    </OverlayTrigger>
                  </h6>
                </Card.Header>
                {paymentProvider ==="stripe" &&    <Card.Body className="tailwind-prefix">
                 <div className="profile-settings-payment-intro">
                  <div>
                    <div className="profile-settings-payment-title">{t("Saved payment methods")}</div>
                    <div className="profile-settings-payment-copy">
                      {t("Keep one card ready so accepted leads and subscriptions do not get delayed.")}
                    </div>
                  </div>
                </div>
                 
             


                 {isFetchSavedCardrun && !addNewCardDetailsOpen ? <SavedCardSkeleton /> : (
                 <div className="profile-payment-card-grid">
                 {!addNewCardDetailsOpen && savedCards.map((d:any)=>{
                  const card = d
                   return     <div
                   key={card.id || card.paymentMethodId}
                   className="profile-payment-card"
                 >
                   <div className="profile-payment-card__header">
                     <div className="profile-payment-card__identity">
                       <div className="profile-payment-card__icon">
                         <CreditCard size={22} aria-hidden="true" />
                       </div>
                       <div className="profile-payment-card__details">
                         <strong>{String(card.card.brand || "Card").toUpperCase()}</strong>
                         <span>•••• {card.card.last4}</span>
                       </div>
                     </div>
                     <div className="profile-payment-card__meta">
                       {d.isPrimary ? <span className="profile-payment-card__default"><CheckCircle2 size={13} /> Default</span> : null}
                       <span className="profile-payment-card__expiry-label">Expires</span>
                       <strong>{card.card.exp_month ? `${String(card.card.exp_month).padStart(2, "0")}/` : ""}{card.card.exp_year}</strong>
                     </div>
                   </div>

                     <div className="profile-payment-card__footer">
 {!d.isPrimary && (
   <button
     onClick={() => {
       setAlertDetails({
         status: true,
         title: "Confirm Change",
         message: "Are you sure you want to make this card your primary card?",
         icon: IoCheckmarkCircle,
         button1Text: "Cancel",
         button2Text: "Yes, Make Primary",
         button1Style:
           "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200",
         button2Style:
           "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700",
         onButton1Click: () => {},
         onButton2Click: () => {
           handlePrimaryCard(d);
         },
       });
     }}
     className="profile-payment-card__action"
   >
     Make Primary
   </button>
 )}

 <button
   onClick={() => {
     if (d.isPrimary) {
       setAlertDetails({
         status: true,
         title: "Warning!",
         message:
           "You can't detach your primary card. Please make another card primary first.",
         icon: IoWarning,
         button1Text: "Cancel",
         button2Text: "Add New Card",
         button1Style:
           "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200",
         button2Style:
           "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700",
         onButton1Click: () => {},
         onButton2Click: () => {
           setAddNewCardDetailsOpen(true);
         },
       });
     } else {
       setAlertDetails({
         status: true,
         title: "Warning!",
         message:
           "You’re about to detach your card. Are you sure you want to proceed?",
         icon: IoTrashOutline,
         button1Text: "Cancel",
         button2Text: "Detach",
         button1Style:
           "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200",
         button2Style:
           "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700",
         onButton1Click: () => {},
         onButton2Click: () => {
           detachCard(d);
         },
       });
     }
   }}
   className="profile-payment-card__action is-danger"
 >
   Detach
 </button>
                   </div>
                 </div>
                 })}
                 </div>
                 )}
                 {!isFetchSavedCardrun && !addNewCardDetailsOpen && savedCards.length === 0 && <NoSavedCard />}
                 {addNewCardDetailsOpen && <Row className="mt-3">
                   <Elements stripe={ isEmployee?stripePromiseTest: stripePromise}>
                     <Stripe
                       onCancel={() => {
                         setAddNewCardDetailsOpen(false);
                       }}
                       onSuccess={(savedCard: any)=>{
                         fetchSavedCard()
                         offerPendingPaymentRecovery(savedCard?.paymentMethodId)
                       }}
                       setStatus={setAddNewCardDetailsOpen}
                       userEmail={userD && userD.user_email}
                       hasSavedCards={savedCards.length > 0}
                     />
                     </Elements>

                 </Row>  }
             
                 
                 { !addNewCardDetailsOpen && !isFetchSavedCardrun && (
                   <div className="">
                     <Button
                       onClick={() => {
                         setAddNewCardDetailsOpen(true);
                       }}
                       className="profile-payment-add-button mt-3"
                     >
                       {t("Add Card")}
                     </Button>
                   </div>
                 )}
               </Card.Body>}
           {paymentProvider ==="deluxe"&&      <Card.Body className="tailwind-prefix">
           <div className="profile-settings-payment-intro">
            <div>
              <div className="profile-settings-payment-title">{t("Saved payment methods")}</div>
              <div className="profile-settings-payment-copy">
                {t("Saved Cards appear here after they are verified.")}
              </div>
            </div>
          </div>
                 
           {isFetchSavedCardrun && !addNewCardDetailsOpen ? <SavedCardSkeleton /> : (
           <div className="profile-payment-card-grid">
           {!addNewCardDetailsOpen && savedCards.map((d:any)=>{
            const card = d
             return     <div
             key={card.paymentMethodId}
             className="profile-payment-card"
           >
             <div className="profile-payment-card__header">
               <div className="profile-payment-card__identity">
                 <div className="profile-payment-card__icon">
                   <CreditCard size={22} aria-hidden="true" />
                 </div>
                 <div className="profile-payment-card__details">
                   <strong>{String(card.cardType || "Card").toUpperCase()}</strong>
                   <span>{card.maskedPan || "Saved payment method"}</span>
                 </div>
               </div>
               <div className="profile-payment-card__meta">
                 {d.isPrimary ? <span className="profile-payment-card__default"><CheckCircle2 size={13} /> Default</span> : null}
                 <span className="profile-payment-card__expiry-label">Expires</span>
                 <strong>{d.expiry}</strong>
               </div>
             </div>
             <div className="profile-payment-card__provider"><ShieldCheck size={14} /> Secured by Deluxe</div>
             <div className="profile-payment-card__footer">
               {!d.isPrimary && (
                 <button
                   type="button"
                   onClick={() => {
                     setAlertDetails({
                       status: true,
                       title: "Confirm Change",
                       message: "Are you sure you want to make this card your primary card?",
                       icon: IoCheckmarkCircle,
                       button1Text: "Cancel",
                       button2Text: "Yes, Make Primary",
                       button1Style:
                         "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200",
                       button2Style:
                         "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700",
                       onButton1Click: () => {},
                       onButton2Click: () => {
                         handlePrimaryCard(d);
                       },
                     });
                   }}
                   className="profile-payment-card__action"
                 >
                   Make Primary
                 </button>
               )}
             </div>
           </div>
           })}
           </div>
           )}
           {!isFetchSavedCardrun && !addNewCardDetailsOpen && savedCards.length === 0 && <NoSavedCard />}

           {addNewCardDetailsOpen && (
             <Row className="mt-3">
               <Col lg={12}>
                 {deluxeMessage && (
                   <Alert
                     variant="danger"
                     onClose={() => setDeluxeMessage("")}
                     dismissible
                   >
                     {deluxeMessage}
                   </Alert>
                 )}
                 <div
                   id="profile-deluxe-embeddedpayments"
                   className={`${deluxeSdkRendered ? "opacity-100" : "opacity-0"} transition-opacity`}
                 />
                 {!deluxeSdkRendered && <SavedCardSkeleton />}
                 {deluxeSdkRendered && (
                   <div className="d-flex gap-2 mt-3">
                     <Button
                       className="btn-secondary bg-gradient"
                       disabled={isSavingDeluxeCard}
                       onClick={() => EmbeddedPayments.pay(deluxeJwt)}
                     >
                       {isSavingDeluxeCard ? "Saving..." : "Save Card"}
                     </Button>
                     <Button
                       className="btn-light bg-gradient"
                       disabled={isSavingDeluxeCard}
                       onClick={() => setAddNewCardDetailsOpen(false)}
                     >
                       Cancel
                     </Button>
                   </div>
                 )}
               </Col>
             </Row>
           )}

           {!addNewCardDetailsOpen && !isFetchSavedCardrun && (
             <div className="">
               <Button
                 onClick={() => {
                   setAddNewCardDetailsOpen(true);
                 }}
                 className="profile-payment-add-button mt-3"
               >
                 {t("Add Card")}
               </Button>
             </div>
           )}

     
       
       
       
      
         </Card.Body>}
              </Card>
            </Tab.Pane>
          </Tab.Content>

          {/*Fifth Recent Work */}
          <Tab.Content>
            <Tab.Pane eventKey="fifth" id="recentWork">
              <RecentWorkList contractorId={userD && userD.id} />
            </Tab.Pane>
          </Tab.Content>

          {/* 
          <Tab.Content>
            <Tab.Pane eventKey="fourth" id="changePassword">
              <Card>
                <div className="tab-pane" id="changePassword" role="tabpanel">
                  <Card.Header>
                    <h6 className="card-title mb-0">Changes Password</h6>
                  </Card.Header>
                  <Card.Body>
                    <Form action="/pages-profile-settings">
                      <Row className=" g-2 justify-content-lg-between align-items-center">
                        <Col lg={4}>
                          <div>
                            <Form.Label
                              htmlFor="oldpasswordInput"
                              className="form-label"
                            >
                              Old Password*
                            </Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="password"
                                id="oldpasswordInput"
                                placeholder="Enter current password"
                                autoComplete="off"
                              />
                              <Button
                                variant="link"
                                className="position-absolute top-0 end-0 text-decoration-none text-muted password-addon"
                                id="passwordAddon"
                              >
                                <i className="ri-eye-fill align-middle"></i>
                              </Button>
                            </div>
                          </div>
                        </Col>

                        <Col lg={4}>
                          <div className="auth-pass-inputgroup">
                            <Form.Label
                              htmlFor="password-input"
                              className="form-label"
                            >
                              New Password*
                            </Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="password"
                                className="password-input"
                                id="password-input"
                                onPaste={(e) => e.preventDefault()}
                                placeholder="Enter new password"
                                aria-describedby="passwordInput"
                                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                required
                                autoComplete="off"
                              />
                              <Button
                                variant="link"
                                className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                id="password-addon"
                              >
                                <i className="ri-eye-fill align-middle"></i>
                              </Button>
                            </div>
                          </div>
                        </Col>

                        <Col lg={4}>
                          <div className="auth-pass-inputgroup">
                            <Form.Label htmlFor="confirm-password-input">
                              Confirm Password*
                            </Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type="password"
                                className="password-input"
                                onPaste={(e) => e.preventDefault()}
                                id="confirmPasswordInput"
                                placeholder="Confirm password"
                                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                required
                                autoComplete="off"
                              />
                              <Button
                                variant="link"
                                className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                id="#confirm-password-input"
                              >
                                <i className="ri-eye-fill align-middle"></i>
                              </Button>
                            </div>
                          </div>
                        </Col>
                        <div className="d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="link-primary text-decoration-underline"
                          >
                            Forgot Password ?
                          </Link>
                          <div className="">
                            <Button type="submit" variant="success">
                              Change Password
                            </Button>
                          </div>
                        </div>

                        <Col lg={12}>
                          <Card
                            className=" bg-light shadow-none passwd-bg"
                            id="password-contain"
                          >
                            <Card.Body>
                              <div className="mb-4">
                                <h5 className="fs-sm">
                                  Password must contain:
                                </h5>
                              </div>
                              <div className="">
                                <p
                                  id="pass-length"
                                  className="invalid fs-xs mb-2"
                                >
                                  Minimum <b>8 characters</b>
                                </p>
                                <p
                                  id="pass-lower"
                                  className="invalid fs-xs mb-2"
                                >
                                  At <b>lowercase</b> letter (a-z)
                                </p>
                                <p
                                  id="pass-upper"
                                  className="invalid fs-xs mb-2"
                                >
                                  At least <b>uppercase</b> letter (A-Z)
                                </p>
                                <p
                                  id="pass-number"
                                  className="invalid fs-xs mb-0"
                                >
                                  A least <b>number</b> (0-9)
                                </p>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </Form>
                    <div className="mt-4 mb-4 pb-3 border-bottom d-flex justify-content-between align-items-center">
                      <h5 className="card-title  mb-0">Login History</h5>
                      <div className="flex-shrink-0">
                        <Button variant="secondary">All Logout</Button>
                      </div>
                    </div>

                    <Row>
                      <Col lg={12}>
                        <div className="table-responsive">
                          <Table className="table table-borderless align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">Mobile</th>
                                <th scope="col">IP Address</th>
                                <th scope="col">Date</th>
                                <th scope="col">Address</th>
                                <th scope="col">
                                  <i className="ri-logout-box-r-line"></i>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <i className="bi bi-phone align-baseline me-1"></i>{" "}
                                  iPhone 12 Pro
                                </td>
                                <td>192.44.234.160</td>
                                <td>18 Dec, 2023</td>
                                <td>Los Angeles, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-tablet align-baseline me-1"></i>{" "}
                                  Apple iPad Pro
                                </td>
                                <td>192.44.234.162</td>
                                <td>03 Jan, 2023</td>
                                <td>Phoenix, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-phone align-baseline me-1"></i>{" "}
                                  Galaxy S21 Ultra 5G
                                </td>
                                <td>192.45.234.54</td>
                                <td>25 Feb, 2023</td>
                                <td>Washington, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-laptop align-baseline me-1"></i>{" "}
                                  Dell Inspiron 14
                                </td>
                                <td>192.40.234.32</td>
                                <td>16 Oct, 2022</td>
                                <td>Phoenix, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-phone align-baseline me-1"></i>{" "}
                                  iPhone 12 Pro
                                </td>
                                <td>192.44.326.42</td>
                                <td>22 May, 2022</td>
                                <td>Conneticut, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-tablet align-baseline me-1"></i>{" "}
                                  Apple iPad Pro
                                </td>
                                <td>190.44.182.33</td>
                                <td>19 Nov, 2023</td>
                                <td>Los Angeles, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <i className="bi bi-phone align-baseline me-1"></i>{" "}
                                  Galaxy S21 Ultra 5G
                                </td>
                                <td>194.44.235.87</td>
                                <td>30 Aug, 2022</td>
                                <td>Conneticut, United States</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="icon-link icon-link-hover"
                                  >
                                    Logout{" "}
                                    <i className="bi bi-box-arrow-right"></i>
                                  </Link>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </div>
              </Card>
            </Tab.Pane>
          </Tab.Content> */}
        </Tab.Container>
      </Col>
      <Modal
        show={pendingRecoveryCard.show}
        onHide={closePendingPaymentConsent}
        centered
        backdrop="static"
        keyboard={!isRecoveringSubscription}
        className="pending-payment-consent-modal"
        aria-labelledby="pending-payment-consent-title"
      >
        <Modal.Header closeButton={!isRecoveringSubscription}>
          <div className="pending-payment-consent-modal__icon">
            <ShieldCheck size={22} aria-hidden="true" />
          </div>
          <div>
            <Modal.Title id="pending-payment-consent-title">Pay outstanding subscription balance?</Modal.Title>
            <p>Your new card has been saved successfully.</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="pending-payment-consent-modal__amount">
            <span>Outstanding amount</span>
            <strong>
              {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(billingAccess?.outstandingAmount || 0))}
            </strong>
          </div>
          <p className="pending-payment-consent-modal__copy">
            Your previous subscription payment failed. You can authorize us to charge this newly added card now and restore your subscription service immediately.
          </p>
          <Form.Check
            id="authorize-pending-subscription-payment"
            type="checkbox"
            checked={recoveryConsentAccepted}
            disabled={isRecoveringSubscription}
            onChange={(event) => setRecoveryConsentAccepted(event.target.checked)}
            label={`I authorize a one-time charge of ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(billingAccess?.outstandingAmount || 0))} to this new card.`}
          />
          {recoveryError ? <Alert variant="danger" className="mt-3 mb-0">{recoveryError}</Alert> : null}
          <div className="pending-payment-consent-modal__notice">
            Your card will remain saved even if you choose “Not now” or if this payment is declined.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" disabled={isRecoveringSubscription} onClick={closePendingPaymentConsent}>
            Not now — keep card saved
          </Button>
          <Button
            variant="primary"
            disabled={!recoveryConsentAccepted || isRecoveringSubscription}
            onClick={() => void recoverPendingPaymentWithNewCard()}
          >
            {isRecoveringSubscription ? <><Spinner animation="border" size="sm" className="me-2" />Processing payment…</> : "Authorize & pay now"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal create video payment */}
      <Modal
        size="lg"
        show={modal_video_payment}
        onHide={() => {
          tog_modal_video_payment();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
        data-bs-focus="false"
      >
        <Modal.Body className="text-center  tailwind-prefix">
          <div className="">
            <div className="flex justify-end">
              <button onClick={()=>{
                 tog_modal_video_payment();
              }} className="border-0 bg-white">
              <i className="bi bi-x-lg text-red-500 text-[18px]" />

              </button>
            </div>
            <h4 className="mb-2 mt-2" style={{ textTransform: "capitalize" }}>
              Your free corporate video has exceeded the time duration limit of
              30 seconds.
            </h4>
            <img
              style={{ maxWidth: "300px" }}
              src={girlScrolling}
              className="img-fluid"
            />
            <p className="mb-3">
              No worries. You can always increase the time duration limit of
              your Corporate Video by just paying a minimal amount of $33.99.
            </p>
            <p className="mb-3">
              Pay $33.99/monthly or $350/annually now and enjoy a time duration
              limit of 60 seconds.
            </p>
            <div className="hstack gap-4 justify-content-center">
              <Button
                className="btn btn-primary"
                onClick={() => handleVideoPackageFunc("Monthly")}
              >
                {" "}
                Monthly - $33.99
              </Button>
              <Button
                className="btn btn-success"
                onClick={() => handleVideoPackageFunc("Annually")}
              >
                Annually - $350
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {paymentProvider ==="stripe" ?  <SubscriptionModal
        afterSubmit={() => {
          setSubriptionModalStatus(false);
          setIsPackagesLoading(true);
          void dispatch(getSubscribedUser()).finally(() => setIsPackagesLoading(false));

          setAlertDetails({
            status: true,
            title: "🎉 Subscription Completed!",
            message:
              "You can now create contracts. Check out our guide to get started!",
            icon: IoCheckmarkCircleOutline, // ✅ Success-style icon (you can import this from react-icons)
            button1Text: "Create Contract",
            button2Text: "Start Now",
            button1Style:
              "px-4 py-2 rounded-lg bg-blue text-black hover:bg-blue-600 transition",
            button2Style:
              "px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition",
            onButton1Click: () => {
              navigate("/get-contracts");
            },
            onButton2Click: () => {
              navigate("/get-contracts");
            },
          });
        }}
        
        plan={planDetails}
        trialEligible={trialEligible}
        isOpen={subriptionModalStatus}
        onClose={() => {
          setSubriptionModalStatus(false);
        }}
      />: <DeluxeSubscriptionModal
      afterSubmit={() => {
        setSubriptionModalStatus(false);
        setIsPackagesLoading(true);
        void dispatch(getSubscribedUser()).finally(() => setIsPackagesLoading(false));

        setAlertDetails({
          status: true,
          title: "🎉 Subscription Completed!",
          message:
            "You can now create contracts. Check out our guide to get started!",
          icon: IoCheckmarkCircleOutline, // ✅ Success-style icon (you can import this from react-icons)
          button1Text: "Create Contract",
          button2Text: "Start Now",
          button1Style:
            "px-4 py-2 rounded-lg bg-blue text-black hover:bg-blue-600 transition",
          button2Style:
            "px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition",
          onButton1Click: () => {
            navigate("/get-contracts");
          },
          onButton2Click: () => {
            navigate("/get-contracts");
          },
        });
      }}
      
      plan={planDetails}
      trialEligible={trialEligible}
      isOpen={subriptionModalStatus}
      onClose={() => {
        setSubriptionModalStatus(false);
      }}
    />}
    

     
      <ToastContainer />
      <TwoButtonAlert setDetails={setAlertDetails} details={alertDetails} />
      <SubscriptionCancelldModal onClose={()=>{
        setIsSUbCanceldOpen(false)
      }} isOpen={isSubCancelledOpen}/>
    </React.Fragment>
  );
};

export default Personal;

interface PricingCardProps {
  plan: {
    id: number;
    price: string;
    plan: string;
    start: string;
    ribbon: boolean;
    firstPayment?: string;
    interval: string;
    plan_type: string;
    actext: Array<{
      id: number;
      [key: string]: string | number;
    }>;
  };
  onClick: () => void;
  title: string;
  isCurrentPlan: boolean;
  trialEligible: boolean;
  disabled?: boolean;
  actionNote?: string;
}
export function PricingCard({ plan, onClick, title, isCurrentPlan, trialEligible, disabled = false, actionNote }: PricingCardProps) {
  const { t } = useTranslation();
  const features = Object.entries(plan.actext[0])
    .filter(([key]) => key.startsWith("act"))
    .map(([_, value]) => value as string);

  const isAnnual = plan.plan_type === "yearly";
  const visibleFeatures = features.slice(0, 6);
  const additionalFeatures = features.slice(6);

  return (
    <article
      className={`profile-settings-pricing-card${isAnnual ? " is-featured" : ""}${isCurrentPlan ? " is-current" : ""}`}
      aria-label={`${plan.plan} ${t("subscription plan")}`}
    >
      <div className="profile-settings-pricing-card-accent" aria-hidden="true" />
      <div className="profile-settings-pricing-badges">
        {isAnnual && (
          <span className="profile-settings-pricing-badge is-value">
            <Sparkles aria-hidden="true" /> {t("Best value")}
          </span>
        )}
        {isCurrentPlan && (
          <span className="profile-settings-pricing-badge is-current">
            <CheckCircle2 aria-hidden="true" /> {t("Current plan")}
          </span>
        )}
      </div>

      <div className="profile-settings-pricing-card-header">
        <div>
          <span className="profile-settings-pricing-plan-label">
            {isAnnual ? t("Pay once a year") : t("Flexible monthly billing")}
          </span>
          <h3>{plan.plan}</h3>
        </div>
        {!isCurrentPlan && trialEligible ? <span className="profile-settings-pricing-trial">{t("30 days free")}</span> : null}
      </div>

      <div className="profile-settings-pricing-price-row">
        <strong>{plan.price}</strong>
        <span>/{plan.interval}</span>
      </div>
      <p className="profile-settings-pricing-billing-note">
        {isAnnual
          ? t("Equivalent to $358.33/month, billed annually")
          : trialEligible ? t("Billed monthly after your free trial") : t("Billed monthly starting today")}
      </p>

      {isAnnual ? (
        <div className="profile-settings-pricing-saving">
          <span>{t("Save $200 every year")}</span>
          <small>{t("compared with monthly billing")}</small>
        </div>
      ) : (
        <div className="profile-settings-pricing-highlight-spacer" aria-hidden="true" />
      )}

      <button
        type="button"
        className={`profile-settings-pricing-action${isCurrentPlan ? " is-current" : ""}`}
        onClick={onClick}
        disabled={disabled}
      >
        {title}
      </button>
      <span className="profile-settings-pricing-action-note">
        {actionNote || (isCurrentPlan
          ? t("Your access remains active through the current billing period")
          : trialEligible
          ? t("No charge today · Cancel anytime")
          : t("Payment starts today · Cancel anytime"))}
      </span>

      <div className="profile-settings-pricing-features">
        <div className="profile-settings-pricing-features-heading">
          <strong>{t("Everything included")}</strong>
          <span>{features.length} {t("benefits")}</span>
        </div>
        <ul>
          {visibleFeatures.map((feature) => (
            <li key={feature}>
              <span className="profile-settings-pricing-check"><Check aria-hidden="true" /></span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        {additionalFeatures.length > 0 && (
          <details className="profile-settings-pricing-more">
            <summary>{t("View all included benefits")} <span aria-hidden="true">+</span></summary>
            <ul>
              {additionalFeatures.map((feature) => (
                <li key={feature}>
                  <span className="profile-settings-pricing-check"><Check aria-hidden="true" /></span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </details>
        )}
      </div>
    </article>
  );
}
